// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:58:15.555Z
// Property: Stonepost Ranch Apartment Homes (ID: 6767906449167617)
// Collections: 42 amenities, 12 floorplans (live), 27 photos, 76 POIs, 4 reviews, 12 virtual tours, 6 office hours, 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167617",
  "property_external_id": "1124404",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/stonepost-ranch-apartment-homes-overland-park-ks/94v0247/",
  "property_google_business_url": "https://www.google.com/maps/place/Stonepost+Ranch+Apartment+Homes/@38.8822643,-94.7348717,891m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0bffa65636691:0x97ed2206e621ff3d!8m2!3d38.8822643!4d-94.7348717!16s%2Fg%2F1wcxdmbs?entry=ttu&g_ep=EgoyMDI2MDkxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124404 p1099355",
  "property_status": null,
  "property_slug": "stonepost-ranch-apartment-homes",
  "property_name": "Stonepost Ranch Apartment Homes",
  "property_website_url": "https://www.stonepostranchapts.com/",
  "property_domain": "https://www.stonepostranchapts.com/",
  "property_address": "12801 W 136th St",
  "property_full_address": "12801 W 136th St, Overland Park, KS 66221",
  "property_address_1": "12801 W 136th St",
  "property_address_2": null,
  "property_address_city": "Overland Park",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66221",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Outlying Johnson County KS",
  "property_address_latitude": "38.882046",
  "property_address_longitude": "-94.7374545",
  "property_email": "rentcafe.sp@pricekc.com",
  "property_phone": "(913) 361-6522",
  "property_call_tracking_phone": "913-361-6522",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>South Overland Park comfort with room to spread out.</strong> Explore one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with polished in-home details, then picture everyday downtime with <a href=\"/amenities\">resort-style amenities</a> just outside your door—schedule your tour today.</p>",
  "property_long_description": "<p>Stonepost Ranch Apartment Homes is a pet-friendly apartment community near 135th Street in Overland Park, KS, with two swimming pools, including a zero-depth lagoon pool with a sand beach, and a golf driving range and putting green. The community is managed by Price Brothers Management, a Kansas City family-owned company since 1922.</p><p>Residents at Stonepost Ranch also have basketball and sand volleyball courts, two fitness centers, and two clubhouses. If you’re searching for apartments for rent in Overland Park with more to do close to home, explore our <a href=\"/floor-plans\">floor plans</a>, take a <a href=\"/virtual-tours\">virtual tour</a>, or <a href=\"/schedule-a-tour\">schedule a visit</a>.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-4948-7102-b60f-7c2dc993c382.webp",
  "property_featured_image_media": {
    "alt_text": "Open-concept living and dining area with a modern kitchen.",
    "public_id": "01a0b66d-4948-7102-b60f-7c2dc993c382",
    "storage_key": "property/6767906449167617/01a0b66d-4948-7102-b60f-7c2dc993c382.webp",
    "width": 1200,
    "height": 800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "492",
  "property_year_built": "2004",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": "200",
  "property_application_fee": "60",
  "property_fees_deposit_info": "Deposit: $175-375",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://stonepostranchapts.securecafeapplicant.com/onlineleasing/content3/access/stonepost-ranch0/floorplans",
  "property_resident_portal_url": "https://stonepostranchapts.securecafe.com/residentservices/stonepost-ranch0/userlogin.aspx",
  "property_apply_now_url": "https://stonepostranchapts.securecafeapplicant.com/onlineleasing/content3/access/stonepost-ranch0/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-2774-707e-945f-34dea27b3f29.webp",
  "property_primary_logo_media": {
    "alt_text": "Stonepost Ranch Apartment Homes logo",
    "public_id": "019fc98b-2774-707e-945f-34dea27b3f29",
    "storage_key": "property/6767906449167617/019fc98b-2774-707e-945f-34dea27b3f29.webp",
    "width": 1538,
    "height": 394
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a13ff6-8618-779e-a39e-8923e37d3e35.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Stonepost logo",
    "public_id": "01a13ff6-8618-779e-a39e-8923e37d3e35",
    "storage_key": "property/6767906449167617/01a13ff6-8618-779e-a39e-8923e37d3e35.webp",
    "width": 1538,
    "height": 394
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a7-d14b-770b-84b4-51fd808f88b7.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019ff6a7-d14b-770b-84b4-51fd808f88b7",
    "storage_key": "property/6767906449167617/019ff6a7-d14b-770b-84b4-51fd808f88b7.webp",
    "width": 1280,
    "height": 327
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#531900",
  "property_secondary_color": "#2C5697",
  "property_font_color": null,
  "property_color_4": "#007672",
  "property_color_3": "#FFC15E",
  "property_color_5": "#F7934C",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "592 - 1321",
  "property_sqft_min": "592",
  "property_sqft_max": "1321",
  "property_price_range": "1223 - 9083",
  "property_price_min": "1223",
  "property_price_max": "9083",
  "property_available_units": 24,
  "property_facebook_url": "https://www.facebook.com/StonepostRanch",
  "property_instagram_url": "https://www.instagram.com/stonepostranch/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJkWZjZfq_wIcRPf8h5gYi7Zc",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Stonepost Ranch Apartment Homes",
  "property_home_romance_title": "Find Your Blissful Retreat at Our Apartment Community",
  "property_home_amenities_blurb": "<p>Take a dip in one of two swimming pools, unwind by the lagoon pool’s sandy beach, or relax at the cabana with its outdoor TV. Stay active at two fitness centers, the basketball and sand volleyball courts, or the golf driving range and putting green. Enjoy billiards and shuffleboard, or make use of the business center and meeting spaces.</p>",
  "property_home_floorplans_blurb": "<p>Choose from 12 one-, two-, and three-bedroom floor plans ranging from 592 to 1,321 square feet. Enjoy everyday conveniences such as a full-size washer and dryer, spacious closets, 9-foot ceilings, and a private patio or balcony. Select homes offer kitchen islands, pantries, private studies with French doors, formal dining areas, and attached garages. Explore our Ranch and Valley phases, each offering distinct interior finishes.</p>",
  "property_home_gallery_blurb": "<p><strong>See Stonepost Ranch in focus.</strong> Preview sunlit kitchens, open living spaces, crown molding, built-in desks, garden-style baths, and balconies with room to pause. Then step into resort-inspired community scenes, from the lagoon-style pool and sand beach to the cabana with outdoor TV, clubhouse games, grilling greens, and putting green. Browse the gallery for a fuller look at life in Overland Park.</p>",
  "property_home_neighborhood_blurb": "<p>Located near 135th Street in Overland Park, Stonepost Ranch offers access to shopping, dining, parks, and everyday essentials. With connections to I-35, I-435, and US-69, exploring Johnson County and the greater Kansas City area is convenient.</p>",
  "property_home_reviews_blurb": "<p><strong>What stands out in the reviews?</strong> Friendly, professional service, prompt maintenance, quiet surroundings, and well-kept grounds come up again and again. Residents mention smooth move-ins, attentive upkeep, spacious layouts that feel like home, and everyday conveniences like pools, fitness centers, garages, and modern finishes. Explore the reviews to see what makes Stonepost Ranch a comfortable place to come home to in Overland Park.</p>",
  "property_neighborhood_blurb": "<p>Stonepost Ranch Apartment Homes is located near 135th Street and South Pflumm Road in Overland Park, KS, with quick access to I-35, I-435, and US-69 for commutes across Johnson County and the Kansas City metro.</p><p>Overland Pointe Marketplace is close by for shopping and everyday errands. Looking for a place to eat near Stonepost Ranch? Our team recommends The Big Biscuit for breakfast, Nick the Greek for a quick lunch, and The Other Place in Olathe for dinner and drinks. For coffee, try Sweet Tee’s Coffee Shop or grab something on the go at 7 Brew Coffee. Finish the night with frozen yogurt at Fifth &amp; Emery, or stop by Whataburger for a late-night craving.</p><p>For time outdoors, the Scheels Overland Park Soccer Complex and Deanna Rose Children’s Farmstead are both nearby. Johnson County Community College and major Johnson County employers are an easy commute from Stonepost Ranch.</p><p><a href=\"/floor-plans\">Explore our floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Stonepost Ranch Apartment Homes brings resort-style amenities to luxury apartments in Overland Park, including a zero-depth lagoon pool with a sand beach, a second swimming pool, and a golf driving range and putting green. Residents also have two fitness centers, two clubhouses, and basketball and sand volleyball courts.</p><p>Looking for apartments with garages in Overland Park? Select Stonepost Ranch homes include an attached garage, and detached garages are available throughout the community.</p><p>Inside, every apartment has a full-size washer and dryer, an all-electric kitchen, extra storage, 9-foot ceilings, and a private patio or balcony. Select layouts add stainless steel appliances, a kitchen island, or vaulted ceilings. <a href=\"/schedule-a-tour\">Schedule a tour</a> to see it for yourself.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Stonepost Ranch home?</strong> Choose a one-, two-, or three-bedroom apartment with everyday comforts like an included washer and dryer, 9-foot ceilings, spacious closets, and a private patio or balcony. Start your online application today and take the next step toward South Overland Park comfort.</p>",
  "property_contactus_blurb": "<p>Have questions? We’re here to help! Whether you’re exploring <a href=\"/floor-plans\">floor plans</a>, checking availability, or learning about community <a href=\"/amenities\">amenities</a>, the Stonepost Ranch leasing team would love to hear from you.</p><p>Give us a call, send a message, or visit our leasing office in Overland Park, KS. We’re happy to help you explore your options.</p><p>Already a resident? Visit the <a href=\"/resident-access\">Resident Portal</a> to make a payment or submit a maintenance request.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Stonepost Ranch?</strong> Start here for quick answers about floor plans, community features, leasing, and everyday living in South Overland Park. If you don’t see what you need, the leasing team is happy to help you find the right next step.</p>",
  "property_floorplans_blurb": "<p>Find a space that feels like home at Stonepost Ranch Apartment Homes. Our 12 one-, two-, and three-bedroom floor plans range from 592 to 1,321 square feet, giving you options for the way you live.</p><p>Apartments feature full-size washers and dryers, spacious closets, 9-foot ceilings, garden soaking tubs, and private patios or balconies. Explore the Ranch Phase with maple cabinetry and the Valley Phase with rich espresso cabinetry and stainless steel appliances. Stainless steel appliances are also available in select Ranch Phase homes. Additional features in select layouts include kitchen islands, pantries, private studies, formal dining rooms, mudrooms, attached garages, and wood-style flooring.</p><p>Browse floor plans, compare current pricing and availability, or <a href=\"/schedule-a-tour\">schedule a tour</a> to find your favorite.</p>",
  "property_gallery_blurb": "<p>Take a closer look at life at Stonepost Ranch Apartment Homes. From spacious apartment interiors to inviting outdoor spaces, our photo gallery gives you a glimpse of the community.</p><p>Picture yourself enjoying coffee on your private patio or balcony, spending an afternoon at one of our pools, or gathering for a game of volleyball. Explore apartment interiors, clubhouses, landscaped grounds, and community amenities.</p><p>Like what you see? Take a <a href=\"/virtual-tours\">virtual tour</a> or <a href=\"/schedule-a-tour\">schedule an in-person visit</a>.</p>",
  "property_interactivemap_blurb": "<p>Finding your next apartment just got easier. Explore Stonepost Ranch Apartment Homes with our interactive property map and discover available apartments in Overland Park, KS.</p><p>Browse the community, compare apartment locations, and explore <a href=\"/floor-plans\">floor plans</a> and features. Select an available home to review its layout and availability, then begin your online application when you’re ready.</p><p>Have questions or want to visit in person? Our <a href=\"/contact-us\">leasing team</a> is here to help.</p><h2>How Interactive Leasing Works</h2><ul><li>Filter available homes by the features that matter most to you.</li><li>Select a home on the map to view its floor plan and availability.</li><li>Start your application online once you’ve chosen a home.</li></ul>",
  "property_pets_blurb": "<p>Your four-legged companions are welcome at Stonepost Ranch Apartment Homes. Our pet-friendly apartments in Overland Park, KS offer comfortable living spaces for you and your pets.</p><p>Cats and dogs are welcome, with up to two pets permitted per apartment home. Please contact the leasing team for the latest details on permitted animals, including rabbits, and applicable restrictions. Eligible residents may also enjoy benefits through the <a href=\"https://www.pricebrotherskc.com/petroyaltyclub/\" target=\"_blank\">Price Brothers Pet Royalty Club</a>.</p><p>Have questions about pet fees, breed restrictions, or policies? Our <a href=\"/contact-us\">leasing team</a> can help you learn more before moving.</p><h2>Pet Fees and Guidelines</h2><ul><li>Maximum of two pets per home</li><li>Monthly pet rent: $25 per pet</li><li>One-time nonrefundable pet fee: $300 for one pet or $500 for two pets</li><li>Breed restrictions apply; contact the leasing office for details</li><li>Contact the leasing office to confirm permitted animal types and current policies</li></ul><h2>Assistance Animals</h2><p>Assistance animals are not considered pets. Stonepost Ranch Apartment Homes considers reasonable accommodation requests for assistance animals in accordance with applicable Fair Housing requirements. Contact the leasing office with questions about the accommodation process.</p>",
  "property_referafriend_blurb": "<p><strong>Share the comfort of Stonepost Ranch.</strong> Invite a friend to discover spacious one-, two-, and three-bedroom homes with everyday polish, plus resort-style spaces made for relaxing, gathering, and staying active—all in a South Overland Park setting with room to spread out.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Stonepost Ranch.</strong> Pay rent, submit maintenance requests, and manage your account in a few clicks—so you can get back to enjoying everyday comfort, from spacious apartment details to resort-style community spaces.</p>",
  "property_reviews_blurb": "<p><strong>See why residents choose to stay.</strong> Reviews for Stonepost Ranch Apartment Homes often highlight the same reassuring details: friendly, professional staff, timely maintenance, quiet surroundings, and well-kept apartments and grounds.</p><p>Residents describe a community where issues are “quick to address,” move-ins feel smooth, and everyday upkeep—from repairs to winter walkway clearing—is handled with care. You’ll also see praise for spacious layouts that “really feel like home,” plus favorite features like the pools, fitness centers, garages, and modern finishes. Read through the reviews below to hear firsthand what makes Stonepost Ranch a comfortable place to come home to in Overland Park.</p>",
  "property_created_at": "1785792716354",
  "property_scheduletour_blurb": "<p>Ready to experience Stonepost Ranch Apartment Homes for yourself? Schedule a visit to explore our <a href=\"/floor-plans\">floor plans</a>, inviting community spaces, and standout <a href=\"/amenities\">amenities</a> in Overland Park, KS.</p><p>Tour the community with our leasing team or explore interactive <a href=\"/virtual-tours\">360° virtual tours</a> from wherever you are. From apartment interiors to our pools and fitness centers, there’s plenty to discover.</p><h2>Choose Your Tour</h2><ul><li>Guided Tour: Schedule an in-person visit with our leasing team.</li><li>Virtual Tour: Explore available interactive 360° walkthroughs online.</li></ul><p>Choose the option that works for you and take the next step toward your new home.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out.</strong> Your submission has been received, and the Stonepost Ranch leasing team will follow up soon. In the meantime, picture South Overland Park comfort with spacious one-, two-, and three-bedroom layouts, polished in-home details, and resort-style spaces designed for everyday ease.</p>",
  "property_virtualtours_blurb": "<p>Explore Stonepost Ranch Apartment Homes from wherever you are. Our interactive 360° apartment tours let you discover available layouts at your own pace.</p><p>Take a closer look at <a href=\"/floor-plans\">floor plans</a>, picture where your furniture might go, and compare the features that matter most. Ready to see more? <a href=\"/schedule-a-tour\">Schedule an in-person tour</a>.</p><h2>One-Bedroom Virtual Tours</h2><p>Explore one-bedroom layouts from 592 to 892 square feet with living areas, kitchens, and spacious closets.</p><h2>Two-Bedroom Virtual Tours</h2><p>Walk through two-bedroom, two-bathroom homes from 1,068 to 1,321 square feet.</p><h2>Three-Bedroom Virtual Tours</h2><p>See three-bedroom, two-bathroom homes from 1,245 to 1,301 square feet with flexible living space.</p>",
  "property_copyright": "2026 All Rights Reserved. Stonepost Ranch Apartment Homes",
  "property_seo_title_home": "Apartments in Overland Park, KS | Stonepost Ranch",
  "property_seo_description_home": "Explore 1-, 2-, & 3-bedroom apartments in Overland Park, KS at Stonepost Ranch, with two pools, fitness centers, and select garages. Schedule a tour.",
  "property_seo_title_floorplans": "1, 2 & 3-Bedroom Apartments in Overland Park, KS",
  "property_seo_description_floorplans": "Explore 12 one-, two-, and three-bedroom floor plans at Stonepost Ranch in Overland Park, KS, ranging from 592 to 1,321 sq. ft.",
  "property_seo_title_amenities": "Overland Park Apartments with Pools & Garages",
  "property_seo_description_amenities": "Discover two pools, two fitness centers, golf amenities, and select apartment homes with garages at Stonepost Ranch in Overland Park, KS.",
  "property_seo_title_gallery": "Stonepost Ranch Apartments | Overland Park Photos",
  "property_seo_description_gallery": "Browse photos of Stonepost Ranch apartments in Overland Park, KS, including apartment interiors, two pools, and inviting community spaces.",
  "property_seo_title_virtualtours": "Overland Park Apartment Virtual Tours | Stonepost",
  "property_seo_description_virtualtours": "Explore available 360° virtual tours of one-, two-, and three-bedroom apartments at Stonepost Ranch in Overland Park, KS.",
  "property_seo_title_interactivemap": "Available Apartments in Overland Park, KS",
  "property_seo_description_interactivemap": "Find apartments for rent in Overland Park, KS. Use the Stonepost Ranch interactive map to explore available homes and apply online.",
  "property_seo_title_neighborhood": "Apartments Near 135th St | Stonepost Ranch",
  "property_seo_description_neighborhood": "Explore Stonepost Ranch apartments near 135th Street in Overland Park, KS, with access to major highways, shopping, dining, and recreation.",
  "property_seo_title_contact": "Contact Stonepost Ranch Apartments | Overland Park",
  "property_seo_description_contact": "Contact Stonepost Ranch Apartment Homes in Overland Park, KS. Call, send a message, or visit our leasing office to learn more.",
  "property_seo_title_faqs": "FAQs | Apartments in Overland Park, KS",
  "property_seo_description_faqs": "Find answers to your questions at Stonepost Ranch in Overland Park, KS. With modern amenities and versatile floor plans, your ideal living awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Overland Park, KS",
  "property_seo_description_reviews": "Discover the vibrant lifestyle at Stonepost Ranch, Overland Park, KS! Hear real resident stories about our exceptional amenities and community.",
  "property_seo_title_applynow": "Apply Now | Apartments in Overland Park, KS",
  "property_seo_description_applynow": "Discover luxury living at Stonepost Ranch, Overland Park, KS. Choose spacious 1-3 bedroom plans with premium amenities. Your dream home awaits!",
  "property_seo_title_residentaccess": "Resident Access | Stonepost Ranch Apartment Homes",
  "property_seo_description_residentaccess": "Log in to your Stonepost Ranch portal for easy rent payments, maintenance requests, and community updates. Your convenient lifestyle in Overland Park awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Stonepost Ranch Apartment Homes",
  "property_seo_description_referafriend": "Refer a friend to Stonepost Ranch in Overland Park, KS! Great neighbors create a vibrant community. Share the joy of living at our beautiful apartments today!",
  "property_seo_title_scheduletour": "Tour Stonepost Ranch Apartments in Overland Park",
  "property_seo_description_scheduletour": "Schedule an in-person tour of Stonepost Ranch Apartment Homes in Overland Park, KS, or explore available 360° virtual tours online.",
  "property_seo_title_privacy": "Privacy Policy | Stonepost Ranch Apartment Homes",
  "property_seo_description_privacy": "At Stonepost Ranch Apartment Homes in Overland Park, KS, your privacy matters. Check out our policy to understand how we protect your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | Stonepost Ranch Apartment Homes",
  "property_seo_description_accessibility": "At Stonepost Ranch in Overland Park, KS, we embrace digital inclusion. Discover our commitment to accessibility for all residents and visitors. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Stonepost Ranch Apartment Homes",
  "property_seo_description_sitemap": "Navigate through Stonepost Ranch Apartment Homes in Overland Park, KS. Find your perfect living space and amenities with our easy-to-use sitemap today!",
  "property_seo_title_thankyou": "Thank You | Stonepost Ranch Apartment Homes",
  "property_seo_description_thankyou": "Thanks for contacting Stonepost Ranch! We'll connect soon to help you find your perfect Overland Park home.",
  "property_seo_title_pets": "Pet-Friendly Apartments in Overland Park, KS",
  "property_seo_description_pets": "Explore pet-friendly apartments at Stonepost Ranch in Overland Park, KS. Review pet fees, monthly rent, and community pet guidelines.",
  "property_updated_at": "1793743005892",
  "amenities": [
    {
      "id": "ec_6382f2a4fc560e99dae651c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126045",
      "title": "Two Clubhouses",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-5657-71ba-80b1-86c6bc4f31d7.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding lounge area at a multifamily property.",
        "public_id": "01a0b66d-5657-71ba-80b1-86c6bc4f31d7",
        "storage_key": "property/6767906449167617/01a0b66d-5657-71ba-80b1-86c6bc4f31d7.webp",
        "width": 1200,
        "height": 900
      },
      "amenity_image_alt_text": "Aerial view of the property at Stonepost Ranch Apartments, Overland Park,Bird's eye view of the community at Stonepost Ranch Apartments, Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ddd827cd9dae70de8c1adc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126054",
      "title": "Zero-Depth Lagoon Pool with Sand Beach",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-54a7-704d-8c11-b68702130241.webp",
      "amenity_image_media": {
        "alt_text": "Beautifully landscaped outdoor swimming pool with lounge chairs",
        "public_id": "01a0b66d-54a7-704d-8c11-b68702130241",
        "storage_key": "property/6767906449167617/01a0b66d-54a7-704d-8c11-b68702130241.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Pool surrounded by trees and seating around it at Stonepost Ranch Apartments, Kansas,Patio with wooden tables and chairs at Stonepost Ranch Apartments, Kansas, 66221,Patio with stone fireplace at Stonepost Ranch Apartments, Overland Park, Kansas,Large Swimming pool surrounded by greenery at Stonepost Ranch Apartments, Overland Park",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e61d25cb239b34b0b6b3a6d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126047",
      "title": "Two Fitness Centers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_045187aa06b1686fc6bc404d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126043",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-55f2-74df-b69a-1cd30e934381.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of a community pool and basketball court surrounded by trees and buildings.",
        "public_id": "01a0b66d-55f2-74df-b69a-1cd30e934381",
        "storage_key": "property/6767906449167617/01a0b66d-55f2-74df-b69a-1cd30e934381.webp",
        "width": 1200,
        "height": 900
      },
      "amenity_image_alt_text": "Aerial view of the residential area at Stonepost Ranch Apartments, Overland Park, 66221",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_544dac2e53d1450bff5265f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126048",
      "title": "Sand Volleyball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_34776e98804ae0536db613af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126044",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc817a86ad2e7c7dab1984d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126053",
      "title": "Pool Cabana with Outdoor TV",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-54b3-718e-b54a-36317944f840.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a0b66d-54b3-718e-b54a-36317944f840",
        "storage_key": "property/6767906449167617/01a0b66d-54b3-718e-b54a-36317944f840.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Swimming pool view at Stonepost Ranch Apartments, Overland Park, KS, 66221,Swimming Pool with Relaxing lounge chairs at Stonepost Ranch Apartments, Overland Park, 66221",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31ebf6ee1891e007e000e390",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126055",
      "title": "Golf Driving Range & Putting Green",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc1f91b0adcd8b267561cc56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126052",
      "title": "Billiards and Shuffleboard Tables",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f1b86943b2c934a53635fcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126056",
      "title": "Meeting Room / Work-From-Home Space",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_92c58bf587b101a0704ea798",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126051",
      "title": "Notary Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e480982f14c8f77d8bb9c062",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "129032668",
      "title": "Wellness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_184585510c72e462a4eca96b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "106912873",
      "title": "Smoke Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0af8cc3860aa263329260aab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "122755401",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_97c1e4361f10e30dee2df82c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126088",
      "title": "Washer & Dryer Included",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-5a3f-725f-a6cf-36b94b4aa4c8.webp",
      "amenity_image_media": {
        "alt_text": "Washer and dryer unit in a laundry closet.",
        "public_id": "01a0b66d-5a3f-725f-a6cf-36b94b4aa4c8",
        "storage_key": "property/6767906449167617/01a0b66d-5a3f-725f-a6cf-36b94b4aa4c8.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Washer & Dryer at Stonepost Ranch Apartments, Overland Park, 66221",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c814544154e37b1e9ce7fe5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126082",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-6511-7023-ba3e-abb4588c7f34.webp",
      "amenity_image_media": {
        "alt_text": "Balcony with seating, table, and grill overlooking neighborhood.",
        "public_id": "01a0b66d-6511-7023-ba3e-abb4588c7f34",
        "storage_key": "property/6767906449167617/01a0b66d-6511-7023-ba3e-abb4588c7f34.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Balcony with railing at Stonepost Ranch Apartments, Overland Park, KS, 66221",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df304e4a3042580f3d465b1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126076",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-6bc7-73ce-b72d-87a2e4dc9c55.webp",
      "amenity_image_media": {
        "alt_text": "Double vanity with dual sinks and mirrors, and an open closet with clothes.",
        "public_id": "01a0b66d-6bc7-73ce-b72d-87a2e4dc9c55",
        "storage_key": "property/6767906449167617/01a0b66d-6bc7-73ce-b72d-87a2e4dc9c55.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Bathroom with storage cabinet at Stonepost Ranch Apartments, Overland Park",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_727dcf53700125384fe9eefa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126075",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e58c084f919cf8a8c8f7e83d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126074",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7247afc9b206901df13140a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126060",
      "title": "9-Foot Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-7ce2-737f-9f5a-d35a7bed5459.webp",
      "amenity_image_media": {
        "alt_text": "Living room and kitchen area with dining table and bar seating",
        "public_id": "01a0b66d-7ce2-737f-9f5a-d35a7bed5459",
        "storage_key": "property/6767906449167617/01a0b66d-7ce2-737f-9f5a-d35a7bed5459.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Living room with Dining room and Kitchen view at Stonepost Ranch Apartments, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c0ae4b06779d797ef4a6dd0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126059",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-88ad-74e9-aca5-5ddcccc5cf4e.webp",
      "amenity_image_media": {
        "alt_text": "Open concept living room and kitchen with dining area.",
        "public_id": "01a0b66d-88ad-74e9-aca5-5ddcccc5cf4e",
        "storage_key": "property/6767906449167617/01a0b66d-88ad-74e9-aca5-5ddcccc5cf4e.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Living room with ceiling fan and light at Stonepost Ranch Apartments, Overland Park, KS, 66221",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_779934ec2ceaf7e197a4dbeb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88151162",
      "title": "Attached Garage*",
      "amount": "false",
      "description": "*with Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0f109e87ccb9a44730edf923",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "123005051",
      "title": "Detached Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09533cbe2107573fc1dec0db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126080",
      "title": "Gourmet Kitchen*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-71a5-70c0-a2f3-709ffc759be1.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
        "public_id": "01a0b66d-71a5-70c0-a2f3-709ffc759be1",
        "storage_key": "property/6767906449167617/01a0b66d-71a5-70c0-a2f3-709ffc759be1.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Well Equipped Kitchen at Stonepost Ranch Apartments, Overland Park, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1713c0276abbfc5f022b8db3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88151174",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "*in All Valley Phase Homes and Select Ranch Phase Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7c7d2da9af75b096ea65ffcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126081",
      "title": "Kitchen Island*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-7ee7-734a-b686-61fb21578309.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with light wood cabinets, black appliances, granite countertops, and a breakfast bar with seating.",
        "public_id": "01a0b66d-7ee7-734a-b686-61fb21578309",
        "storage_key": "property/6767906449167617/01a0b66d-7ee7-734a-b686-61fb21578309.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Kitchen with brown wooden cabinets at Stonepost Ranch Apartments, Kansas, 66221",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00ccf40e3a0d8de0b609a163",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "122011541",
      "title": "Stone Countertops*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb73078ab7233cf6e785f308",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126071",
      "title": "Rich Dark Finish Cabinetry*",
      "amount": "false",
      "description": "*in All Valley Phase Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-9975-740f-8968-ef77ecef304c.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a microwave.",
        "public_id": "01a0b66d-9975-740f-8968-ef77ecef304c",
        "storage_key": "property/6767906449167617/01a0b66d-9975-740f-8968-ef77ecef304c.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Kitchen with dark brown wood cabinetry at Stonepost Ranch Apartments, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40f2d1ffbcf5d94245fa7c5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126069",
      "title": "Kitchen Pantry*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fcce0118ff188a5298b8f6f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126070",
      "title": "Private Patio Entrance from Main Bedroom*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a19fa9f67141f24ba54a5691",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "121174158",
      "title": "Wood/Vinyl Floors*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_59797389234d686ae127c0fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126085",
      "title": "Private Study with French Doors*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-83b1-76b9-ac9c-42cbacd525b4.webp",
      "amenity_image_media": {
        "alt_text": "Home office with a white desk and chair, laptop, and closet with clothes.",
        "public_id": "01a0b66d-83b1-76b9-ac9c-42cbacd525b4",
        "storage_key": "property/6767906449167617/01a0b66d-83b1-76b9-ac9c-42cbacd525b4.webp",
        "width": 2914,
        "height": 1943
      },
      "amenity_image_alt_text": "Private study with ceiling fan at Stonepost Ranch Apartments, Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce7c077c172a96a12e60b8f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126063",
      "title": "Entrance Foyer*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7605b33d2d2fc33e871d3dab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126084",
      "title": "Mud Room*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-935f-7369-86cd-9b5fe8ed5226.webp",
      "amenity_image_media": {
        "alt_text": "Entryway with coats on a rack and a bench, leading to a living room with a ceiling fan.",
        "public_id": "01a0b66d-935f-7369-86cd-9b5fe8ed5226",
        "storage_key": "property/6767906449167617/01a0b66d-935f-7369-86cd-9b5fe8ed5226.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Mud room with shoe storage at Stonepost Ranch Apartments, Overland Park, 66221",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c7ffbab7312280215718e3bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126079",
      "title": "Formal Dining Room*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aba4bbe510f3477f26dfe740",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126083",
      "title": "Luxurious Primary Bathroom*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-a037-74ec-9ed2-dea9fd74f496.webp",
      "amenity_image_media": {
        "alt_text": "Bathroom vanity with dual sinks, granite countertops, and a walk-in closet.",
        "public_id": "01a0b66d-a037-74ec-9ed2-dea9fd74f496",
        "storage_key": "property/6767906449167617/01a0b66d-a037-74ec-9ed2-dea9fd74f496.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Luxurious master bathroom at Stonepost Ranch Apartments, Overland Park, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d503063d525138ad54efb2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126065",
      "title": "Garden Soaking Tub",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-a01a-757b-ad8a-40380c4ec791.webp",
      "amenity_image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower/tub combo.",
        "public_id": "01a0b66d-a01a-757b-ad8a-40380c4ec791",
        "storage_key": "property/6767906449167617/01a0b66d-a01a-757b-ad8a-40380c4ec791.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Bathroom with glass separated shower at Stonepost Ranch Apartments, Kansas, 66221",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c59a89e8f3e85bad82ea0562",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126078",
      "title": "Coffered Ceiling*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37d06e5c0b98cf8b845f0147",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88151172",
      "title": "Faux Wood Blinds*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_793105830e4eb7a2565bd150",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126077",
      "title": "Architectural Window Trim*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_174898e57d39190d437d1750",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126062",
      "title": "Crown Molding & Wainscoting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-a549-706c-93e5-0205d6b68e64.webp",
      "amenity_image_media": {
        "alt_text": "Dining area and kitchen with island, stainless steel appliances, and granite countertops.",
        "public_id": "01a0b66d-a549-706c-93e5-0205d6b68e64",
        "storage_key": "property/6767906449167617/01a0b66d-a549-706c-93e5-0205d6b68e64.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Bright Kitchen at Stonepost Ranch Apartments, Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ece57d926c2657985bc7390",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "external_id": "88126067",
      "title": "High-Speed Internet Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_5c383f33926b7c805ad72440",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-4948-7102-b60f-7c2dc993c382.webp",
      "image_media": {
        "alt_text": "Open-concept living and dining area with a modern kitchen.",
        "public_id": "01a0b66d-4948-7102-b60f-7c2dc993c382",
        "storage_key": "property/6767906449167617/01a0b66d-4948-7102-b60f-7c2dc993c382.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious open-concept living, dining, and kitchen area perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Open-concept living and dining area with a modern kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-12801 W 136th-2(1).jpg"
    },
    {
      "id": "ec_5388f6ed2fa9d67563117dae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-e1fb-753a-b71c-b0f58f1027c2.webp",
      "image_media": {
        "alt_text": "Living room and dining area with modern furniture, ceiling fan, and large windows.",
        "public_id": "01a0b66d-e1fb-753a-b71c-b0f58f1027c2",
        "storage_key": "property/6767906449167617/01a0b66d-e1fb-753a-b71c-b0f58f1027c2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this spacious apartment featuring a well-appointed living room and dining area, perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "Living room and dining area with modern furniture, ceiling fan, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-12801 W 136th St-4 copy_final(1).jpg"
    },
    {
      "id": "ec_aa440ca28798a99fd592df06",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-c769-73d8-b621-66a023297a83.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and dark wood cabinets.",
        "public_id": "01a0b66d-c769-73d8-b621-66a023297a83",
        "storage_key": "property/6767906449167617/01a0b66d-c769-73d8-b621-66a023297a83.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring granite countertops, a double sink, stainless steel dishwasher, and dark wood cabinets, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and dark wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-12801 W 136th-1(1).jpg"
    },
    {
      "id": "ec_4ef48ac169dde1ef88150fa4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-e22b-74ab-9d03-9a8d07426ebf.webp",
      "image_media": {
        "alt_text": "Modern kitchen with espresso machine, stainless steel oven, microwave, and granite countertops.",
        "public_id": "01a0b66d-e22b-74ab-9d03-9a8d07426ebf",
        "storage_key": "property/6767906449167617/01a0b66d-e22b-74ab-9d03-9a8d07426ebf.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring rich wood cabinetry, granite countertops, a built-in microwave, and a sleek espresso machine, perfect for brewing your morning coffee.",
      "link": "false",
      "alt_text": "Modern kitchen with espresso machine, stainless steel oven, microwave, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-12801 W 136th St-12 copy_final(1).jpg"
    },
    {
      "id": "ec_3e6c1f06ecb9bc64c80b7d73",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-e238-7099-9f14-e0077e03ee43.webp",
      "image_media": {
        "alt_text": "Bedroom with a white dresser, ceiling fan, and abstract art.",
        "public_id": "01a0b66d-e238-7099-9f14-e0077e03ee43",
        "storage_key": "property/6767906449167617/01a0b66d-e238-7099-9f14-e0077e03ee43.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a white dresser with lamps, a ceiling fan, and decorative art on the walls. A view into the kitchen is visible through an open doorway.",
      "link": "false",
      "alt_text": "Bedroom with a white dresser, ceiling fan, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-12801 W 136th St-9 copy_final(1).jpg"
    },
    {
      "id": "ec_04319dcb024b67ce7865c298",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-e280-7398-baba-e2931a65a707.webp",
      "image_media": {
        "alt_text": "Double vanity with two sinks and a large mirror, with a closet to the left containing clothes on hangers.",
        "public_id": "01a0b66d-e280-7398-baba-e2931a65a707",
        "storage_key": "property/6767906449167617/01a0b66d-e280-7398-baba-e2931a65a707.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bathroom with a double vanity, ample storage, and a walk-in closet, offering both style and functionality.",
      "link": "false",
      "alt_text": "Double vanity with two sinks and a large mirror, with a closet to the left containing clothes on hangers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-12801 W 136th St-11 copy_final(1).jpg"
    },
    {
      "id": "ec_e7efd0e2251e84c7176f4c99",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-cfdb-7282-99bb-44e767a0e512.webp",
      "image_media": {
        "alt_text": "Balcony with dining set, grill, and scenic view of neighborhood",
        "public_id": "01a0b66d-cfdb-7282-99bb-44e767a0e512",
        "storage_key": "property/6767906449167617/01a0b66d-cfdb-7282-99bb-44e767a0e512.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening drinks on your private balcony, complete with a grill for outdoor cooking and dining.",
      "link": "false",
      "alt_text": "Balcony with dining set, grill, and scenic view of neighborhood",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-12801 W 136th-4(1).jpg"
    },
    {
      "id": "ec_aadf2ccd28685d9ba4848afb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-da12-7066-b951-be6061146267.webp",
      "image_media": {
        "alt_text": "Entryway with coats hanging on hooks and a bench below. Bookshelves are on the side.",
        "public_id": "01a0b66d-da12-7066-b951-be6061146267",
        "storage_key": "property/6767906449167617/01a0b66d-da12-7066-b951-be6061146267.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A welcoming entryway features a coat rack, bench, and built-in bookshelves, leading into the main living area.",
      "link": "false",
      "alt_text": "Entryway with coats hanging on hooks and a bench below. Bookshelves are on the side.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-12801 W 136th-3(1).jpg"
    },
    {
      "id": "ec_975973d7dddea2d75e85cbf5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-f93a-77ae-80d2-df395f945988.webp",
      "image_media": {
        "alt_text": "Living room with a kitchen island and dining area.",
        "public_id": "01a0b66d-f93a-77ae-80d2-df395f945988",
        "storage_key": "property/6767906449167617/01a0b66d-f93a-77ae-80d2-df395f945988.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A beautifully staged living room and dining area, featuring a modern kitchen island with bar stools, a plush sofa, and elegant decor.",
      "link": "false",
      "alt_text": "Living room with a kitchen island and dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-12801 W 136th St-16 copy_final(1).jpg"
    },
    {
      "id": "ec_f58ab5022446a9e7e022b771",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-0961-774b-a7f4-49f0f8e46438.webp",
      "image_media": {
        "alt_text": "Living room and kitchen with breakfast bar and seating area.",
        "public_id": "01a0b66e-0961-774b-a7f4-49f0f8e46438",
        "storage_key": "property/6767906449167617/01a0b66e-0961-774b-a7f4-49f0f8e46438.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A modern living room and kitchen area featuring a breakfast bar with bar stools, a comfortable sofa, and a coffee table. The space is bright and airy with natural light.",
      "link": "false",
      "alt_text": "Living room and kitchen with breakfast bar and seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-12801 W 136th St-15 copy_final(1).jpg"
    },
    {
      "id": "ec_e459eadda9a749e104c60db2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-ee92-724b-9fb3-6ddc5d8f225c.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, white appliances, and a view into the living area.",
        "public_id": "01a0b66d-ee92-724b-9fb3-6ddc5d8f225c",
        "storage_key": "property/6767906449167617/01a0b66d-ee92-724b-9fb3-6ddc5d8f225c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A spacious kitchen featuring wood cabinetry, a double sink, dishwasher, microwave, stove, and refrigerator. The open layout provides a view into the living space.",
      "link": "false",
      "alt_text": "Kitchen with wood cabinets, white appliances, and a view into the living area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-12801 W 136th St-20 copy_final(1).jpg"
    },
    {
      "id": "ec_6f661de27d754fae66181851",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-ef5e-7097-be05-147b04611d1e.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with dual sinks and a walk-in closet.",
        "public_id": "01a0b66d-ef5e-7097-be05-147b04611d1e",
        "storage_key": "property/6767906449167617/01a0b66d-ef5e-7097-be05-147b04611d1e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bathroom with a dual-sink vanity and a walk-in closet, offering ample storage and a clean, modern aesthetic.",
      "link": "false",
      "alt_text": "Bathroom vanity with dual sinks and a walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-12801 W 136th St-23 copy_final(1).jpg"
    },
    {
      "id": "ec_695c36c188b93d084d6ff113",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-f0bd-717b-b35d-b62399332124.webp",
      "image_media": {
        "alt_text": "Washer and dryer in laundry closet.",
        "public_id": "01a0b66d-f0bd-717b-b35d-b62399332124",
        "storage_key": "property/6767906449167617/01a0b66d-f0bd-717b-b35d-b62399332124.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your convenience.",
      "link": "false",
      "alt_text": "Washer and dryer in laundry closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/34-12801 W 136th St-34.jpg"
    },
    {
      "id": "ec_0c9ae9cd8eb2ff4a66a1e955",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-f7d8-7441-b7d8-e01d56008af5.webp",
      "image_media": {
        "alt_text": "Home office space with a white desk, chair, laptop, and closet.",
        "public_id": "01a0b66d-f7d8-7441-b7d8-e01d56008af5",
        "storage_key": "property/6767906449167617/01a0b66d-f7d8-7441-b7d8-e01d56008af5.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Create your ideal home office in this versatile space, featuring a modern desk, comfortable seating, and ample closet storage.",
      "link": "false",
      "alt_text": "Home office space with a white desk, chair, laptop, and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-12801 W 136th-5(1).jpg"
    },
    {
      "id": "ec_e37ca0e8ab175dc62e489ae2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-fa05-7359-a70a-be4e4999f98b.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen in an apartment.",
        "public_id": "01a0b66d-fa05-7359-a70a-be4e4999f98b",
        "storage_key": "property/6767906449167617/01a0b66d-fa05-7359-a70a-be4e4999f98b.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "The dining area and kitchen are elegantly appointed with modern fixtures and ample counter space, perfect for entertaining.",
      "link": "false",
      "alt_text": "Dining area and kitchen in an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-12801 W 136th St-32 copy_final(1).jpg"
    },
    {
      "id": "ec_e14a72f2150a23540f24d108",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-1173-74f9-a757-cb7510c59fd7.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wood cabinets, black appliances, granite countertops, and a breakfast bar with stools.",
        "public_id": "01a0b66e-1173-74f9-a757-cb7510c59fd7",
        "storage_key": "property/6767906449167617/01a0b66e-1173-74f9-a757-cb7510c59fd7.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring ample cabinet space, sleek black appliances, and a convenient breakfast bar perfect for casual dining.",
      "link": "false",
      "alt_text": "Modern kitchen with wood cabinets, black appliances, granite countertops, and a breakfast bar with stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-12801 W 136th St-31 copy_final(1).jpg"
    },
    {
      "id": "ec_246f8239e0556bb82354846b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-017d-7049-8468-ba9f06133c1d.webp",
      "image_media": {
        "alt_text": "Bathroom with wood vanity, white countertop, sink, toilet, and bathtub with glass enclosure.",
        "public_id": "01a0b66e-017d-7049-8468-ba9f06133c1d",
        "storage_key": "property/6767906449167617/01a0b66e-017d-7049-8468-ba9f06133c1d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into a bright and clean bathroom featuring a spacious vanity with ample storage, a modern sink, and a relaxing bathtub perfect for unwinding.",
      "link": "false",
      "alt_text": "Bathroom with wood vanity, white countertop, sink, toilet, and bathtub with glass enclosure.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-12801 W 136th St-33 copy_final(1).jpg"
    },
    {
      "id": "ec_4ea1c8a55ed4dec94d241742",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-194f-704e-ac6e-4176bc71d760.webp",
      "image_media": {
        "alt_text": "Resort-style pool with in-water lounge chairs and umbrellas at sunset.",
        "public_id": "01a0b66e-194f-704e-ac6e-4176bc71d760",
        "storage_key": "property/6767906449167617/01a0b66e-194f-704e-ac6e-4176bc71d760.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax by our stunning resort-style pool, featuring comfortable in-water lounge chairs and umbrellas, perfect for enjoying a beautiful sunset.",
      "link": "false",
      "alt_text": "Resort-style pool with in-water lounge chairs and umbrellas at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-13810 South Pflumm Rd-9 copy.jpg"
    },
    {
      "id": "ec_5bbf7b84adfd071cea217130",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-0338-749a-9f3d-cd59c552dcae.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and lush landscaping.",
        "public_id": "01a0b66e-0338-749a-9f3d-cd59c552dcae",
        "storage_key": "property/6767906449167617/01a0b66e-0338-749a-9f3d-cd59c552dcae.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by beautiful greenery and comfortable lounge chairs. Perfect for relaxing and soaking up the sun.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-13810 South Pflumm Rd-1.jpg"
    },
    {
      "id": "ec_62bcb35c50ddf60859657572",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-0c63-734a-a537-cfee5d1d7922.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a0b66e-0c63-734a-a537-cfee5d1d7922",
        "storage_key": "property/6767906449167617/01a0b66e-0c63-734a-a537-cfee5d1d7922.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and refreshing umbrellas. An ideal spot for a summer day.",
      "link": "false",
      "alt_text": "Outdoor swimming pool area with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-13810 South Pflumm Rd-7.jpg"
    },
    {
      "id": "ec_f86c5a57aac958cb532df689",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-54b3-718e-b54a-36317944f840.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a0b66d-54b3-718e-b54a-36317944f840",
        "storage_key": "property/6767906449167617/01a0b66d-54b3-718e-b54a-36317944f840.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and a covered area perfect for sunny days.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-13810 South Pflumm Rd-8.jpg"
    },
    {
      "id": "ec_cabc80b6d2d6835a21f0a785",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-0fe3-72cd-b3be-2572c3d9561d.webp",
      "image_media": {
        "alt_text": "Outdoor patio with a stone fireplace and grill, tables, chairs, and umbrellas.",
        "public_id": "01a0b66e-0fe3-72cd-b3be-2572c3d9561d",
        "storage_key": "property/6767906449167617/01a0b66e-0fe3-72cd-b3be-2572c3d9561d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining on the spacious patio, complete with a built-in stone fireplace and grill, comfortable seating, and shaded areas.",
      "link": "false",
      "alt_text": "Outdoor patio with a stone fireplace and grill, tables, chairs, and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-13810 South Pflumm Rd-4.jpg"
    },
    {
      "id": "ec_011824de578382b39a635350",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-1244-74ea-a828-724640a0c7d3.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with tables, chairs, and ceiling fans.",
        "public_id": "01a0b66e-1244-74ea-a828-724640a0c7d3",
        "storage_key": "property/6767906449167617/01a0b66e-1244-74ea-a828-724640a0c7d3.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our covered seating area, complete with tables, chairs, and ceiling fans, perfect for relaxation or entertaining.",
      "link": "false",
      "alt_text": "Outdoor seating area with tables, chairs, and ceiling fans.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-13810 South Pflumm Rd-5.jpg"
    },
    {
      "id": "ec_75908db64dcc7fcb539206e7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-55f2-74df-b69a-1cd30e934381.webp",
      "image_media": {
        "alt_text": "Aerial view of a community pool and basketball court surrounded by trees and buildings.",
        "public_id": "01a0b66d-55f2-74df-b69a-1cd30e934381",
        "storage_key": "property/6767906449167617/01a0b66d-55f2-74df-b69a-1cd30e934381.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy resort-style living with our sparkling swimming pool, spacious sundeck, and a full-size basketball court. Perfect for relaxation and recreation.",
      "link": "false",
      "alt_text": "Aerial view of a community pool and basketball court surrounded by trees and buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-13810 South Pflumm Rd-13.jpg"
    },
    {
      "id": "ec_4cd90859a56abcb62741ee8c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66d-5657-71ba-80b1-86c6bc4f31d7.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding lounge area at a multifamily property.",
        "public_id": "01a0b66d-5657-71ba-80b1-86c6bc4f31d7",
        "storage_key": "property/6767906449167617/01a0b66d-5657-71ba-80b1-86c6bc4f31d7.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy our sparkling swimming pool and spacious sundeck, perfect for relaxing and unwinding.",
      "link": "false",
      "alt_text": "Aerial view of a swimming pool and surrounding lounge area at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-13810 South Pflumm Rd-12.jpg"
    },
    {
      "id": "ec_ced3a1d1c37b2ed99e783fb4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-30f8-7589-afc6-e7fb47200cef.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding suburban landscape.",
        "public_id": "01a0b66e-30f8-7589-afc6-e7fb47200cef",
        "storage_key": "property/6767906449167617/01a0b66e-30f8-7589-afc6-e7fb47200cef.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "An aerial view showcases a cluster of apartment buildings nestled within a suburban environment, highlighting the property's integration with its surroundings.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings and surrounding suburban landscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-13810 South Pflumm Rd-10.jpg"
    },
    {
      "id": "ec_2c5519059be8360bace6ac70",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-38ae-714d-a0de-573d728d7e18.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with apartment buildings and single-family homes.",
        "public_id": "01a0b66e-38ae-714d-a0de-573d728d7e18",
        "storage_key": "property/6767906449167617/01a0b66e-38ae-714d-a0de-573d728d7e18.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "An aerial perspective showcases a vibrant community with modern apartment complexes nestled amongst charming single-family residences, surrounded by lush greenery and well-maintained streets.",
      "link": "false",
      "alt_text": "Aerial view of a suburban neighborhood with apartment buildings and single-family homes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-13810 South Pflumm Rd-14.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_6a81b237-d850-4e95-bb6a-6ac44b147b8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "KC Thai",
      "poi_type": "Restaurants",
      "poi_address": "12250 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "Casual restaurant serving classic Thai dishes including curry, pad Thai, and drunken noodles, plus beer and wine.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc991-150f-74c8-a0a0-c75246b2fdde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-150f-74c8-a0a0-c75246b2fdde",
        "storage_key": "property/6767906449167617/019fc991-150f-74c8-a0a0-c75246b2fdde.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://kcthai.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6934694802530345691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kc-thai",
      "poi_latitude": "38.8842526",
      "poi_longitude": "-94.7265698",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-400-2281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb5-72e1-bd70-676606c96f7f",
        "storage_key": "property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMdT1BdXBwIcR26KRai78PGA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_90daf667-3ba2-4b95-9e71-640f178247e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Saki",
      "poi_type": "Restaurants",
      "poi_address": "12084 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "Asian restaurant serving a variety of dishes, including sushi, in a casual environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc991-1a80-70de-87dd-6e13cc4164fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-1a80-70de-87dd-6e13cc4164fc",
        "storage_key": "property/6767906449167617/019fc991-1a80-70de-87dd-6e13cc4164fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.135sakiop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12776580849908502308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saki",
      "poi_latitude": "38.884192",
      "poi_longitude": "-94.7249586",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-685-8858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb5-72e1-bd70-676606c96f7f",
        "storage_key": "property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJheVcOhjBwIcRJM_a-paIT7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_d39d6159-11d1-4758-a2a3-9b7130e400d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Fortune Wok",
      "poi_type": "Restaurants",
      "poi_address": "11236 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "A straightforward Chinese menu plus house specials & sushi served in a polished sit-down setting.",
      "poi_long_description": "A straightforward Chinese menu plus house specials & sushi served in a polished sit-down setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc991-18f9-718b-9aa5-55a3c7bf2d82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-18f9-718b-9aa5-55a3c7bf2d82",
        "storage_key": "property/6767906449167617/019fc991-18f9-718b-9aa5-55a3c7bf2d82.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fortunewokkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1169624398174343166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fortune-wok",
      "poi_latitude": "38.8855259",
      "poi_longitude": "-94.717462",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-239-8646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb5-72e1-bd70-676606c96f7f",
        "storage_key": "property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzSBSLQXAwIcR_s_PdTFXOxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_bb45fa08-f2f5-4af4-a4e0-9e1222788bab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "La Patrona Tacos & Tequila",
      "poi_type": "Restaurants",
      "poi_address": "11240 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "Local option featuring familiar tacos and platters of traditional fare alongside cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66c-1180-71f2-ad56-d2cd67b41b3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-1180-71f2-ad56-d2cd67b41b3e",
        "storage_key": "property/6767906449167617/01a0b66c-1180-71f2-ad56-d2cd67b41b3e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://patronaop.com/overland-park-la-patrona-tacos-and-tequila-food-menu",
      "poi_directions_map_url": "https://maps.google.com/?cid=19863521938798079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-patrona-tacos--tequila",
      "poi_latitude": "38.8855244",
      "poi_longitude": "-94.7175762",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-232-9970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb5-72e1-bd70-676606c96f7f",
        "storage_key": "property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ69mvJjPBwIcR_3UmmcSRRgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_27005900-2262-4b84-8d1b-bfdd6162ce19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "McGregors Butcher & Bistro",
      "poi_type": "Restaurants",
      "poi_address": "11300 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "Steakhouse featuring prime cuts such as filet and rib-eye alongside more casual offerings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-5579-702e-8bd1-7dd044a8d859.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-5579-702e-8bd1-7dd044a8d859",
        "storage_key": "property/6767906449167617/019ff6a8-5579-702e-8bd1-7dd044a8d859.webp",
        "width": 1280,
        "height": 710
      },
      "poi_business_url": "http://www.mcgregorsbutcherandbistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4324700967623380588&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcgregors-butcher--bistro",
      "poi_latitude": "38.8854719",
      "poi_longitude": "-94.717858",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-766-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb5-72e1-bd70-676606c96f7f",
        "storage_key": "property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-3kQYMbBwIcRbM765p1sBDw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bf3fa35a-8f20-4819-b676-f27a5590f008",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "6800 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66b-fd90-75a8-9fd0-4e32a8b60def.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66b-fd90-75a8-9fd0-4e32a8b60def",
        "storage_key": "property/6767906449167617/01a0b66b-fd90-75a8-9fd0-4e32a8b60def.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/ks/overland-park/6800-west-135th-street?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=202371&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=5147810997447030486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "38.885543",
      "poi_longitude": "-94.664569",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-239-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-a6fc-72c8-9790-d1ecbc92d36a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-a6fc-72c8-9790-d1ecbc92d36a",
        "storage_key": "property/6767906449167617/019ff6a8-a6fc-72c8-9790-d1ecbc92d36a.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJHQ380cLBwIcR1vat8dOycEc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_5df0c29a-40c1-4070-9187-2e752e9627e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "7500 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66b-feae-7008-be1e-d92f70499fa6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66b-feae-7008-be1e-d92f70499fa6",
        "storage_key": "property/6767906449167617/01a0b66b-feae-7008-be1e-d92f70499fa6.webp",
        "width": 1280,
        "height": 788
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ks/135th-and-69-hwy?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4057600242659518409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "38.8845447",
      "poi_longitude": "-94.6731579",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-814-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb5-72e1-bd70-676606c96f7f",
        "storage_key": "property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL6zKL9vBwIcRyWdCMOx9Tzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_b765afe0-4466-4466-a244-7e9158881394",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Kyoto Sushi & Steak",
      "poi_type": "Restaurants",
      "poi_address": "6792 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Japanese dining offering sushi & cooked dishes, some prepared at the table by performing chefs.",
      "poi_long_description": "Japanese dining offering sushi & cooked dishes, some prepared at the table by performing chefs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66b-f8e3-740f-8972-d702f9c4da5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66b-f8e3-740f-8972-d702f9c4da5e",
        "storage_key": "property/6767906449167617/01a0b66b-f8e3-740f-8972-d702f9c4da5e.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "http://www.kyotokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=321974629016326996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kyoto-sushi--steak",
      "poi_latitude": "38.8854321",
      "poi_longitude": "-94.6644443",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-239-8868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb5-72e1-bd70-676606c96f7f",
        "storage_key": "property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkxT80cLBwIcRVNM0HTjidwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_402a9c1f-4415-4271-a221-dffc3b031eba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Nick & Jake's Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "6830 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Local bar & grill chain serving classic American fare, pasta, burgers & global bites.",
      "poi_long_description": "Local bar & grill chain serving classic American fare, pasta, burgers & global bites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc991-0b5a-7708-addd-96ca1ce54103.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-0b5a-7708-addd-96ca1ce54103",
        "storage_key": "property/6767906449167617/019fc991-0b5a-7708-addd-96ca1ce54103.webp",
        "width": 975,
        "height": 1233
      },
      "poi_business_url": "http://www.nickandjakes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1372827290254850032&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nick--jakes-overland-park",
      "poi_latitude": "38.8843201",
      "poi_longitude": "-94.6646491",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-681-8535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb5-72e1-bd70-676606c96f7f",
        "storage_key": "property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJexsdCujBwIcR8DeanSVDDRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_001738e8-35f6-4054-9502-a09cc55bc61c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Zarda Bar-B-Q",
      "poi_type": "Restaurants",
      "poi_address": "11931 W 87th St Pkwy, Lenexa, KS 66215, USA",
      "poi_short_description": "BBQ joint serving hickory-smoked ribs, pulled pork & comfort sides in rustic surroundings.",
      "poi_long_description": "BBQ joint serving hickory-smoked ribs, pulled pork & comfort sides in rustic surroundings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66b-fd88-77c8-8f18-4b703d1df927.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66b-fd88-77c8-8f18-4b703d1df927",
        "storage_key": "property/6767906449167617/01a0b66b-fd88-77c8-8f18-4b703d1df927.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.zarda.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14467352450943045629&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zarda-bar-b-q",
      "poi_latitude": "38.9705722",
      "poi_longitude": "-94.7251186",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 913-492-2330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb5-72e1-bd70-676606c96f7f",
        "storage_key": "property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnejof1TrwIcR_U_WHmdcxsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_037d3f28-6814-4734-aa2d-9be3f0ede317",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Jack Stack Barbecue - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "9520 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "Bustling local chain known for its vast barbecue menu encompassing steak & seafood.",
      "poi_long_description": "Bustling local chain known for its vast barbecue menu encompassing steak & seafood.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66b-fe4b-7427-9293-a7ca02db52b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66b-fe4b-7427-9293-a7ca02db52b5",
        "storage_key": "property/6767906449167617/01a0b66b-fe4b-7427-9293-a7ca02db52b5.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.jackstackbbq.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=11966261220374441358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-stack-barbecue---overland-park",
      "poi_latitude": "38.9558013",
      "poi_longitude": "-94.6684419",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 913-385-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb5-72e1-bd70-676606c96f7f",
        "storage_key": "property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTZe4NL7rwIcRjm3zES6zEKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_1d8de053-30a2-4fd2-af6e-4013e4476045",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Q39 - South",
      "poi_type": "Restaurants",
      "poi_address": "11051 Antioch Rd, Overland Park, KS 66210, USA",
      "poi_short_description": "Casual joint for Kansas City BBQ, burgers, wings and sandwiches made in-house, plus a fireplace.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98a-dc85-725b-9cfd-c3a95910b408.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-dc85-725b-9cfd-c3a95910b408",
        "storage_key": "property/6767906449167617/019fc98a-dc85-725b-9cfd-c3a95910b408.webp",
        "width": 960,
        "height": 543
      },
      "poi_business_url": "https://q39kc.com/locations/overland-park-bbq/?utm_source=Google&utm_medium=Maps&utm_campaign=GBP_south",
      "poi_directions_map_url": "https://maps.google.com/?cid=10944240241970651302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "q39---south",
      "poi_latitude": "38.9287968",
      "poi_longitude": "-94.6857828",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-951-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb5-72e1-bd70-676606c96f7f",
        "storage_key": "property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fk1I1bqwIcRpiAy14PA4Zc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_e1aad3a0-b0fd-4c48-95df-f347eee3dc73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Talk of the Town Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "11922 W 119th St, Overland Park, KS 66213, USA",
      "poi_short_description": "Wide-ranging American menu & sizable microbrew selection offered in a casual sports-bar setting.",
      "poi_long_description": "Wide-ranging American menu & sizable microbrew selection offered in a casual sports-bar setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0100e-ce37-7329-ae5c-02ed2aa49762.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100e-ce37-7329-ae5c-02ed2aa49762",
        "storage_key": "property/6767906449167617/01a0100e-ce37-7329-ae5c-02ed2aa49762.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.talkofthetowngrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11519808852011712913&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "talk-of-the-town-grill--bar",
      "poi_latitude": "38.9134106",
      "poi_longitude": "-94.7252605",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-661-9922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb5-72e1-bd70-676606c96f7f",
        "storage_key": "property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX1JPRbTqwIcRkQGPyB2V3p8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bfeddc3f-2761-4dc6-aabd-691e634a0549",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Barley's Kitchen + Tap",
      "poi_type": "Restaurants",
      "poi_address": "11924 W 119th St, Overland Park, KS 66213, USA",
      "poi_short_description": "Brewpub offering a full-length upscale American comfort-food menu, global beer list & TV-watching.",
      "poi_long_description": "Brewpub offering a full-length upscale American comfort-food menu, global beer list & TV-watching.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66c-02a0-74fa-8efe-ff0683c45d80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-02a0-74fa-8efe-ff0683c45d80",
        "storage_key": "property/6767906449167617/01a0b66c-02a0-74fa-8efe-ff0683c45d80.webp",
        "width": 999,
        "height": 888
      },
      "poi_business_url": "http://barleyskitchenandtap.com/op/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7369584364347950482&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barleys-kitchen--tap",
      "poi_latitude": "38.9133583",
      "poi_longitude": "-94.7257415",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-663-4099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb5-72e1-bd70-676606c96f7f",
        "storage_key": "property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr63MWrTqwIcRkoU7A-8FRmY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ff54009c-f152-421f-a3eb-39ab3fba1721",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Tanner's Bar & Grill- 119th",
      "poi_type": "Restaurants",
      "poi_address": "10146 W 119th St, Overland Park, KS 66210, USA",
      "poi_short_description": "Bar & grill chain serving pub grub, burgers, sandwiches & wings in a casual space with TVs.",
      "poi_long_description": "Bar & grill chain serving pub grub, burgers, sandwiches & wings in a casual space with TVs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66c-0505-760c-a551-3aa1292a2a05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-0505-760c-a551-3aa1292a2a05",
        "storage_key": "property/6767906449167617/01a0b66c-0505-760c-a551-3aa1292a2a05.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.tannersbarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9654088726493559933&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tanners-bar--grill--119th",
      "poi_latitude": "38.9137473",
      "poi_longitude": "-94.7025506",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-345-1217",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb5-72e1-bd70-676606c96f7f",
        "storage_key": "property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEcHmrZTqwIcRfXzAFIw2-oU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_f07d4c1c-2947-4f76-98a2-f70a9008c332",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Hen House Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6900 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Casual market, deli and supermarket with fresh produce and a large meat section along with a florist, a bakery, a cafe, prepared foods and bagels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc992-2b22-7458-b394-9578226718f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-2b22-7458-b394-9578226718f1",
        "storage_key": "property/6767906449167617/019fc992-2b22-7458-b394-9578226718f1.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "http://henhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3407519095472349622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hen-house-market",
      "poi_latitude": "38.8856924",
      "poi_longitude": "-94.6657055",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-685-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dbe-7071-b1c9-b8513c82ad55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dbe-7071-b1c9-b8513c82ad55",
        "storage_key": "property/6767906449167617/019fc98b-7dbe-7071-b1c9-b8513c82ad55.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIbLSX93BwIcRtmH9QpDwSS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e42e9e47-addc-4c71-8b9a-b5a47bdf0436",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "8640 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-5b4a-7039-922d-09c5704cbef3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-5b4a-7039-922d-09c5704cbef3",
        "storage_key": "property/6767906449167617/019ff6a8-5b4a-7039-922d-09c5704cbef3.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ks/overland-park/8640-w-135th-street/f302",
      "poi_directions_map_url": "https://maps.google.com/?cid=6421205941781039433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "38.88477",
      "poi_longitude": "-94.68549",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dbe-7071-b1c9-b8513c82ad55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dbe-7071-b1c9-b8513c82ad55",
        "storage_key": "property/6767906449167617/019fc98b-7dbe-7071-b1c9-b8513c82ad55.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnxjMsNLBwIcRSYl8dci0HFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_db78a6bb-0ac5-45a2-876d-e989a732e310",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Hy-Vee Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "8900 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "Bright supermarket stocking local brands and a huge selection of groceries, plus a cafe and pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc992-3a00-7655-9b98-23c7fac792bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-3a00-7655-9b98-23c7fac792bf",
        "storage_key": "property/6767906449167617/019fc992-3a00-7655-9b98-23c7fac792bf.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://www.hy-vee.com/stores/detail.aspx?s=129&utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12053283657012239354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hy-vee-grocery-store",
      "poi_latitude": "38.8852935",
      "poi_longitude": "-94.6882786",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-685-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dbe-7071-b1c9-b8513c82ad55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dbe-7071-b1c9-b8513c82ad55",
        "storage_key": "property/6767906449167617/019fc98b-7dbe-7071-b1c9-b8513c82ad55.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcc01DC3AwIcR-ls8AaDdRac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c8d3dbe1-ffda-4f56-8d9f-d79ed5a3d9e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "8681 W 135th St Walgreens, Overland Park, KS 66223, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-5ed3-73c8-ad80-e155b434a246.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-5ed3-73c8-ad80-e155b434a246",
        "storage_key": "property/6767906449167617/019ff6a8-5ed3-73c8-ad80-e155b434a246.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-8681+w+135th+st-overland+park-ks-66223/id=6920",
      "poi_directions_map_url": "https://maps.google.com/?cid=14836544926270681840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "38.8805102",
      "poi_longitude": "-94.6859559",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-239-9168",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcywI18zBwIcR8PJ8yAD_5c0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_eefb878e-cfaa-4522-9566-0f922c58da0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "12691 Antioch Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc991-7145-73bb-8d81-dbfd5d73d3bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-7145-73bb-8d81-dbfd5d73d3bb",
        "storage_key": "property/6767906449167617/019fc991-7145-73bb-8d81-dbfd5d73d3bb.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/overland-park-ks-pharmacies/12691-antioch-overland-park-ks-66213/storeid=8585?WT.mc_id=LS_GOOGLE_RX_8585",
      "poi_directions_map_url": "https://maps.google.com/?cid=8009062976100597061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.8989109",
      "poi_longitude": "-94.6848773",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-681-9665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-a6b2-73d3-b469-0c85e556d0db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-a6b2-73d3-b469-0c85e556d0db",
        "storage_key": "property/6767906449167617/019ff6a8-a6b2-73d3-b469-0c85e556d0db.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV8dKcX7qwIcRRX01ylfoJW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_3a8fc41d-0507-439f-ac7a-f62179a84dc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "McKeever's Price Chopper",
      "poi_type": "Shopping & Retail",
      "poi_address": "11700 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "Chain shop for groceries and baked goods, plus a selection of deli favorites and prepared foods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc991-808b-736d-a1b8-28b27f286c8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-808b-736d-a1b8-28b27f286c8d",
        "storage_key": "property/6767906449167617/019fc991-808b-736d-a1b8-28b27f286c8d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mypricechopper.com/store-details?storeId=96",
      "poi_directions_map_url": "https://maps.google.com/?cid=2000385917123995709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckeevers-price-chopper",
      "poi_latitude": "38.886436",
      "poi_longitude": "-94.721598",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-685-8666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dbe-7071-b1c9-b8513c82ad55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dbe-7071-b1c9-b8513c82ad55",
        "storage_key": "property/6767906449167617/019fc98b-7dbe-7071-b1c9-b8513c82ad55.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ11oGoqDBwIcRPajeo2TMwhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_77b4565c-da89-4620-baa7-7d5d47a22d6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "11701 Metcalf Ave, Overland Park, KS 66210, USA",
      "poi_short_description": "Department store chain with clothing, electronics, and home goods, plus groceries, and pharmacy services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc991-cc48-775f-9baa-e125e8a1a67d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-cc48-775f-9baa-e125e8a1a67d",
        "storage_key": "property/6767906449167617/019fc991-cc48-775f-9baa-e125e8a1a67d.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1599-overland-park-ks/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9310956249863213418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "38.91484750000001",
      "poi_longitude": "-94.6638388",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-338-2202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dc0-7334-8f99-8347226475ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dc0-7334-8f99-8347226475ef",
        "storage_key": "property/6767906449167617/019fc98b-7dc0-7334-8f99-8347226475ef.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPwmyQxXqwIcRatFMsGApN4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_8e7e8f4b-a0e1-43e8-9c7a-9a304a4b1312",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Scheels",
      "poi_type": "Shopping & Retail",
      "poi_address": "6503 W 135th St STE 88, Overland Park, KS 66223, USA",
      "poi_short_description": "Chain with apparel, shoes & gear for sports & outdoor recreation, plus merchandise with team logos.",
      "poi_long_description": "Chain with apparel, shoes & gear for sports & outdoor recreation, plus merchandise with team logos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66c-13d3-777f-bbb0-a28f5729b709.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-13d3-777f-bbb0-a28f5729b709",
        "storage_key": "property/6767906449167617/01a0b66c-13d3-777f-bbb0-a28f5729b709.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.scheels.com/store/overland-park/088?utm_source=google&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=1094253745788337078&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scheels",
      "poi_latitude": "38.8804238",
      "poi_longitude": "-94.6607748",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-897-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dc0-7334-8f99-8347226475ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dc0-7334-8f99-8347226475ef",
        "storage_key": "property/6767906449167617/019fc98b-7dc0-7334-8f99-8347226475ef.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvUOZyt7BwIcRtrva8_uRLw8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_d3fe0b3d-67a8-4620-87f3-6d83073734bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "REI",
      "poi_type": "Shopping & Retail",
      "poi_address": "6281 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Retail chain carrying gear, apparel & footwear for a wide range of outdoor & fitness activities.",
      "poi_long_description": "Retail chain carrying gear, apparel & footwear for a wide range of outdoor & fitness activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66c-1490-71b1-9e2b-dc83bb7e06db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-1490-71b1-9e2b-dc83bb7e06db",
        "storage_key": "property/6767906449167617/01a0b66c-1490-71b1-9e2b-dc83bb7e06db.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://www.rei.com/stores/overland-park?y_source=1_MTQ1MzQ2NS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2425922740833547199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rei",
      "poi_latitude": "38.8829948",
      "poi_longitude": "-94.6579242",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-402-1938",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dc0-7334-8f99-8347226475ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dc0-7334-8f99-8347226475ef",
        "storage_key": "property/6767906449167617/019fc98b-7dc0-7334-8f99-8347226475ef.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJw6_qcX_VxocRv_PsM-GbqiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_25d6043b-098b-4215-a7ca-5bc2e9a2e722",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "8300 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-5adb-754f-bbb4-dc728b950172.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-5adb-754f-bbb4-dc728b950172",
        "storage_key": "property/6767906449167617/019ff6a8-5adb-754f-bbb4-dc728b950172.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/4707-overland-park-ks",
      "poi_directions_map_url": "https://maps.google.com/?cid=13205436472745682803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "38.8863478",
      "poi_longitude": "-94.6830744",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-402-1405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dc0-7334-8f99-8347226475ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dc0-7334-8f99-8347226475ef",
        "storage_key": "property/6767906449167617/019fc98b-7dc0-7334-8f99-8347226475ef.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJtbHmBtLBwIcRc2f-rYEiQ7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_2e95f065-feee-4b9a-a378-a1074b918ed2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "California Trail Middle School",
      "poi_type": "Education",
      "poi_address": "13775 W 133rd St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.olatheschools.org/californiatrail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4023738896053685227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "california-trail-middle-school",
      "poi_latitude": "38.8860707",
      "poi_longitude": "-94.7466726",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-780-7220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dc1-77e5-933f-cc588638edc7",
        "storage_key": "property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBZgmSP6_wIcR68szEDUx1zc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c6b5f417-62fd-45c4-a1b1-329360319faa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Overland Trail Elementary School",
      "poi_type": "Education",
      "poi_address": "6225 W 133rd St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6cc-d0d2-774f-a301-ad370f598c5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-d0d2-774f-a301-ad370f598c5a",
        "storage_key": "property/6767906449167617/019ff6cc-d0d2-774f-a301-ad370f598c5a.webp",
        "width": 1280,
        "height": 861
      },
      "poi_business_url": "https://www.bluevalleyk12.org/OTE",
      "poi_directions_map_url": "https://maps.google.com/?cid=2244344860322751896&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-trail-elementary-school",
      "poi_latitude": "38.88582210000001",
      "poi_longitude": "-94.6575254",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-239-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dc1-77e5-933f-cc588638edc7",
        "storage_key": "property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJy1sTYGPwIcRmOUCacKDJR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_cb7d4668-9d1b-45a5-9a08-5cb9b66abdec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Overland Trail Middle School",
      "poi_type": "Education",
      "poi_address": "6201 W 133rd St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6cc-ccdf-707d-bf3a-654ad38686a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-ccdf-707d-bf3a-654ad38686a3",
        "storage_key": "property/6767906449167617/019ff6cc-ccdf-707d-bf3a-654ad38686a3.webp",
        "width": 1280,
        "height": 543
      },
      "poi_business_url": "https://www.bluevalleyk12.org/OTM",
      "poi_directions_map_url": "https://maps.google.com/?cid=15599445353126869038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-trail-middle-school",
      "poi_latitude": "38.8855363",
      "poi_longitude": "-94.6545605",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-239-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dc1-77e5-933f-cc588638edc7",
        "storage_key": "property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJy1sTYGPwIcRLrg-NuZcfNg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_97050c6b-5755-482e-9e15-ee801ce24808",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Blue Valley Northwest High School",
      "poi_type": "Education",
      "poi_address": "13260 Switzer Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6cc-ce75-750e-825b-9651b79c19bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-ce75-750e-825b-9651b79c19bb",
        "storage_key": "property/6767906449167617/019ff6cc-ce75-750e-825b-9651b79c19bb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bluevalleyk12.org/bvnw",
      "poi_directions_map_url": "https://maps.google.com/?cid=665158985377803435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-valley-northwest-high-school",
      "poi_latitude": "38.8885806",
      "poi_longitude": "-94.7032351",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-239-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dc1-77e5-933f-cc588638edc7",
        "storage_key": "property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBevbQCHAwIcRq2yaspIeOwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_6b93ecfd-81f6-4ebf-a30e-b73cb45402ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Bentwood Elementary School",
      "poi_type": "Education",
      "poi_address": "13000 Bond St, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.olatheschools.org/bentwood/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5490286288728705891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bentwood-elementary-school",
      "poi_latitude": "38.8911317",
      "poi_longitude": "-94.7220723",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-780-7320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dc1-77e5-933f-cc588638edc7",
        "storage_key": "property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAcXPZXHBwIcRY0vfckpqMUw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6caba845-3905-4ebc-aef3-fc8822f3e28f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "KidZone Learning Center of Overland Park, Inc.",
      "poi_type": "Education",
      "poi_address": "12011 W 127th St, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.kidzonekc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4518174064594336214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kidzone-learning-center-of-overland-park-inc",
      "poi_latitude": "38.8977083",
      "poi_longitude": "-94.7268712",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-308-5431",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dc1-77e5-933f-cc588638edc7",
        "storage_key": "property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmbEpd_nrwIcR1jmHmV_Hsz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_4881b782-0f43-46b8-8608-a9e81c6a74b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "New Horizon Academy",
      "poi_type": "Education",
      "poi_address": "11920 Quivira Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66c-1574-773a-bd9e-5a818b3d4fc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-1574-773a-bd9e-5a818b3d4fc2",
        "storage_key": "property/6767906449167617/01a0b66c-1574-773a-bd9e-5a818b3d4fc2.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.newhorizonacademy.net/location/overland-park-ks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17338355438709389589&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-horizon-academy",
      "poi_latitude": "38.91157",
      "poi_longitude": "-94.7244149",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-400-2670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dc1-77e5-933f-cc588638edc7",
        "storage_key": "property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ11iLHg3rwIcRFTm8sWg2nvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_33e8dc5e-1486-42f3-9750-eace6a94321b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Blue River Elementary School",
      "poi_type": "Education",
      "poi_address": "5101 W 163rd Terrace, Stilwell, KS 66085, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66c-16f1-773c-90d2-0435b59d5e4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-16f1-773c-90d2-0435b59d5e4a",
        "storage_key": "property/6767906449167617/01a0b66c-16f1-773c-90d2-0435b59d5e4a.webp",
        "width": 1280,
        "height": 886
      },
      "poi_business_url": "http://www.bluevalleyk12.org/bre",
      "poi_directions_map_url": "https://maps.google.com/?cid=12902608789590883096&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-river-elementary-school",
      "poi_latitude": "38.83169669999999",
      "poi_longitude": "-94.6425243",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 913-239-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dc1-77e5-933f-cc588638edc7",
        "storage_key": "property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs3afmODDwIcRGLtlS1VGD7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_39416902-b538-415e-9176-610d9b6b5d78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Kansas School for the Deaf",
      "poi_type": "Education",
      "poi_address": "450 E Park St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66c-1a27-737f-a5ed-18360b602430.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-1a27-737f-a5ed-18360b602430",
        "storage_key": "property/6767906449167617/01a0b66c-1a27-737f-a5ed-18360b602430.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kansasdeaf.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13806792647896540422&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-school-for-the-deaf",
      "poi_latitude": "38.8828991",
      "poi_longitude": "-94.8128312",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-210-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dc1-77e5-933f-cc588638edc7",
        "storage_key": "property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrUdAzf29wIcRBiVZAcOUm78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_b930d931-6858-4169-9d53-ab0f86c397cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98a-e56a-700e-a48e-7a0a9ff2be34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-e56a-700e-a48e-7a0a9ff2be34",
        "storage_key": "property/6767906449167617/019fc98a-e56a-700e-a48e-7a0a9ff2be34.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dc1-77e5-933f-cc588638edc7",
        "storage_key": "property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d7c4b7f8-6cc5-4b69-a422-765a22c94279",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "AMC Prairiefire 17",
      "poi_type": "Entertainment",
      "poi_address": "5724 W 136th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Comfortable entertainment venue featuring a full menu alongside movie screenings of new releases.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc992-bfa5-713a-aff1-ec70ad7b32a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-bfa5-713a-aff1-ec70ad7b32a3",
        "storage_key": "property/6767906449167617/019fc992-bfa5-713a-aff1-ec70ad7b32a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-prairiefire-17?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3727223515720771879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-prairiefire-17",
      "poi_latitude": "38.8826984",
      "poi_longitude": "-94.651566",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-553-3075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-a703-71ab-8adf-4f8d5556cc77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-a703-71ab-8adf-4f8d5556cc77",
        "storage_key": "property/6767906449167617/019ff6a8-a703-71ab-8adf-4f8d5556cc77.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7fXu5_DBwIcRJ-kENQrCuTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_e33d233b-a22b-4461-a126-d383e9f785d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "B&B Theatres Overland Park 16",
      "poi_type": "Entertainment",
      "poi_address": "8601 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_long_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc992-f979-71c7-a193-c3df4b882384.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-f979-71c7-a193-c3df4b882384",
        "storage_key": "property/6767906449167617/019fc992-f979-71c7-a193-c3df4b882384.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://www.bbtheatres.com/our-theatres/x0uvh-b-and-b-overland-park-16/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6259761698616561138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bb-theatres-overland-park-16",
      "poi_latitude": "38.8812512",
      "poi_longitude": "-94.6835183",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-871-5352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-a703-71ab-8adf-4f8d5556cc77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-a703-71ab-8adf-4f8d5556cc77",
        "storage_key": "property/6767906449167617/019ff6a8-a703-71ab-8adf-4f8d5556cc77.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJDWO_qc3BwIcR8s2iaBkk31Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_ab195b85-ae02-4262-8d37-5ba7475155bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Museum at Prairiefire",
      "poi_type": "Entertainment",
      "poi_address": "5801 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_long_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98a-fe04-707a-9b64-7f2f5dd7d848.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-fe04-707a-9b64-7f2f5dd7d848",
        "storage_key": "property/6767906449167617/019fc98a-fe04-707a-9b64-7f2f5dd7d848.webp",
        "width": 1170,
        "height": 797
      },
      "poi_business_url": "https://www.visitthemap.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9011883457387750483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-at-prairiefire",
      "poi_latitude": "38.8819446",
      "poi_longitude": "-94.6520905",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-333-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e15b8ac49544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e15b8ac49544",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e15b8ac49544.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdDvHPHBwIcRU-TQ6kGkEH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c8fdadb8-4bd9-41bd-89dc-485b1a3745d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "5901 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Family-friendly venue with pickleball courts and other games, plus a casual restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-57a8-7708-8efa-a0efe48d2ec3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-57a8-7708-8efa-a0efe48d2ec3",
        "storage_key": "property/6767906449167617/019ff6a8-57a8-7708-8efa-a0efe48d2ec3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3904135511973972812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chicken-n-pickle---overland-park",
      "poi_latitude": "38.8830518",
      "poi_longitude": "-94.6552102",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-703-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb5-72e1-bd70-676606c96f7f",
        "storage_key": "property/6767906449167617/019fc98b-7cb5-72e1-bd70-676606c96f7f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9D8rijBwIcRTEsyKpBGLjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5e44f6c9-5dbe-4def-8bc4-48597f845043",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "810 Entertainment - Overland Park",
      "poi_type": "Entertainment",
      "poi_address": "13500 Nall Ave, Overland Park, KS 66224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66c-1a7f-707f-8e7d-e295150d7bfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-1a7f-707f-8e7d-e295150d7bfe",
        "storage_key": "property/6767906449167617/01a0b66c-1a7f-707f-8e7d-e295150d7bfe.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://810bowling.com/810-entertainment-overland-park-ks",
      "poi_directions_map_url": "https://maps.google.com/?cid=11623012279752903673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "810-entertainment---overland-park",
      "poi_latitude": "38.8828352",
      "poi_longitude": "-94.6497927",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-600-7088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ298S-n_BwIcR-cusShY8TaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_2233b475-01bd-4f5a-89a4-19c99fafc41c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Nerman Museum of Contemporary Art",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_long_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98a-f8fe-761d-b1c1-d4e3970402e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-f8fe-761d-b1c1-d4e3970402e0",
        "storage_key": "property/6767906449167617/019fc98a-f8fe-761d-b1c1-d4e3970402e0.webp",
        "width": 1080,
        "height": 830
      },
      "poi_business_url": "http://www.nermanmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4973184191241098516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nerman-museum-of-contemporary-art",
      "poi_latitude": "38.924852",
      "poi_longitude": "-94.726824",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-469-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e15b8ac49544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e15b8ac49544",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e15b8ac49544.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRFJWDQaxMBEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_3e10a6c1-a55f-4817-9da6-32007a82b26a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Deanna Rose Children's Farmstead",
      "poi_type": "Entertainment",
      "poi_address": "13800 Switzer Rd, Overland Park, KS 66221, USA",
      "poi_short_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_long_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc992-9cd4-7177-a657-cad247ddf8a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-9cd4-7177-a657-cad247ddf8a6",
        "storage_key": "property/6767906449167617/019fc992-9cd4-7177-a657-cad247ddf8a6.webp",
        "width": 640,
        "height": 349
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/deanna-rose-childrens-farmstead/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7835830010939554497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deanna-rose-childrens-farmstead",
      "poi_latitude": "38.877729",
      "poi_longitude": "-94.703345",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-897-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6IUwjvAwIcRwbplAuF1vmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e4ab3975-2533-4362-b9d8-c651cc5c6074",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Overland Park Arboretum & Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8909 W 179th St, Overland Park, KS 66013, USA",
      "poi_short_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_long_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-1d5a-75cf-8343-1adf9a81da39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98b-1d5a-75cf-8343-1adf9a81da39",
        "storage_key": "property/6767906449167617/019fc98b-1d5a-75cf-8343-1adf9a81da39.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/recreation-fun/arboretum-botanical-gardens/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8713039177416778041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-arboretum--botanical-gardens",
      "poi_latitude": "38.8033925",
      "poi_longitude": "-94.6891159",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-685-3604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6csjvynHwIcROSH92_fu6ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_cf1e7fe3-b201-470f-873c-492db800da2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Johnson County Arts And Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "8788 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "Cultural center featuring the Johnson County Museum, the KidScape experience, and a theater.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66c-1dec-711d-9dac-745535b67f44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-1dec-711d-9dac-745535b67f44",
        "storage_key": "property/6767906449167617/01a0b66c-1dec-711d-9dac-745535b67f44.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jcprd.com/327/Arts-Heritage-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=6564331375929992564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-arts-and-heritage-center",
      "poi_latitude": "38.9698449",
      "poi_longitude": "-94.6681692",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 913-826-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA2a8po3rwIcRdCVCapswGVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "custom_b9243633-a241-4cfe-aa14-2d8d7f692424",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Clock Tower Landing",
      "poi_type": "Entertainment",
      "poi_address": "7950 Marty St, Overland Park, KS 66204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66c-2110-77ac-8e91-12900242ea75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-2110-77ac-8e91-12900242ea75",
        "storage_key": "property/6767906449167617/01a0b66c-2110-77ac-8e91-12900242ea75.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.opkansas.gov/160/Farmers-Market",
      "poi_directions_map_url": "https://maps.google.com/?cid=15001986399657762431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clock-tower-landing",
      "poi_latitude": "38.9847751",
      "poi_longitude": "-94.6707369",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ6blVADtwIcRf57XhCXDMdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_aadc76db-af75-4af1-a46d-810f1a6cae91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Saint Luke's South Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "12300 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc992-e65b-712a-b4d2-24df8768db65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-e65b-712a-b4d2-24df8768db65",
        "storage_key": "property/6767906449167617/019fc992-e65b-712a-b4d2-24df8768db65.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-south-hospital?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966224544508452770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-south-hospital",
      "poi_latitude": "38.9041982",
      "poi_longitude": "-94.6695167",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-317-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb4-754d-ac5c-2f6084cac3b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb4-754d-ac5c-2f6084cac3b5",
        "storage_key": "property/6767906449167617/019fc98b-7cb4-754d-ac5c-2f6084cac3b5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkT2aF3LqwIcRop_Q17dtbnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_7e7e5f07-2ea8-4d2e-bb63-b373784da606",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Overland Park Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10500 Quivira Rd, Overland Park, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc992-be26-772b-82aa-e33d6a2f963f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-be26-772b-82aa-e33d6a2f963f",
        "storage_key": "property/6767906449167617/019fc992-be26-772b-82aa-e33d6a2f963f.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/overland-park-regional-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13555409796355494155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-regional-medical-center",
      "poi_latitude": "38.9376197",
      "poi_longitude": "-94.7261812",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-541-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb4-754d-ac5c-2f6084cac3b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb4-754d-ac5c-2f6084cac3b5",
        "storage_key": "property/6767906449167617/019fc98b-7cb4-754d-ac5c-2f6084cac3b5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cFCWJzAwIcRC5Ge4GN9Hrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_53ce373b-759b-40bf-b050-be45cd187169",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "AdventHealth Centra Care Overland Park",
      "poi_type": "Health and Wellness",
      "poi_address": "9099 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc992-bc16-761e-9806-fbace9f88dd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-bc16-761e-9806-fbace9f88dd2",
        "storage_key": "property/6767906449167617/019fc992-bc16-761e-9806-fbace9f88dd2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://centracare.adventhealth.com/urgent-care/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16421499770594357393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-centra-care-overland-park",
      "poi_latitude": "38.8832467",
      "poi_longitude": "-94.6909065",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-549-4242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwRwCDLAwIcRkXBvWQnj5OM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_a5b70ea5-103f-488a-a8f0-8b84a7654961",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Children's Mercy Blue Valley",
      "poi_type": "Health and Wellness",
      "poi_address": "6750 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-78ff-724b-be86-cc03d2e7ece7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-78ff-724b-be86-cc03d2e7ece7",
        "storage_key": "property/6767906449167617/019ff6a8-78ff-724b-be86-cc03d2e7ece7.webp",
        "width": 1280,
        "height": 831
      },
      "poi_business_url": "http://www.childrensmercy.org/urgentcare/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12194765778603454721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-blue-valley",
      "poi_latitude": "38.8856523",
      "poi_longitude": "-94.6635513",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-717-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXxWtfTgvd0ARAbG_cN2CPKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_afc51fa6-8782-4777-bb42-8ab44bdf91b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "11900 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66c-1f7e-7038-97b8-035309a62931.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-1f7e-7038-97b8-035309a62931",
        "storage_key": "property/6767906449167617/01a0b66c-1f7e-7038-97b8-035309a62931.webp",
        "width": 1280,
        "height": 770
      },
      "poi_business_url": "https://www.cvs.com/store-locator/overland-park-ks-pharmacies/11900-w-135th-street-overland-park-ks-66221/storeid=8573?WT.mc_id=LS_GOOGLE_FS_8573",
      "poi_directions_map_url": "https://maps.google.com/?cid=16334940416394902490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "38.8865863",
      "poi_longitude": "-94.724268",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-814-7003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqbRvzgbAwIcR2rtjMsNdseI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_1b144d77-da6e-4f81-8f3c-f79379e1dc2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "8681 W 135th St Walgreens, Overland Park, KS 66223, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66c-1f7d-7248-8cfb-8fb7dfc83ebf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-1f7d-7248-8cfb-8fb7dfc83ebf",
        "storage_key": "property/6767906449167617/01a0b66c-1f7d-7248-8cfb-8fb7dfc83ebf.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-8681+w+135th+st-overland+park-ks-66223/id=6920",
      "poi_directions_map_url": "https://maps.google.com/?cid=17124435918803819808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "38.8805173",
      "poi_longitude": "-94.6859519",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-239-9168",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-a6b2-73d3-b469-0c85e556d0db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-a6b2-73d3-b469-0c85e556d0db",
        "storage_key": "property/6767906449167617/019ff6a8-a6b2-73d3-b469-0c85e556d0db.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd_Mv0czBwIcRIN09L703pu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_9d19fb16-bca1-4e80-945e-a7f0916b0f59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "11320 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "Chain gym with tanning and spa facilities, as well as hydroloungers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-0edc-7409-a7ef-ffb9bdf3641b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98b-0edc-7409-a7ef-ffb9bdf3641b",
        "storage_key": "property/6767906449167617/019fc98b-0edc-7409-a7ef-ffb9bdf3641b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/overland-park-135th-st-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1396585211980257129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.88575820000001",
      "poi_longitude": "-94.71868700000002",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-402-0999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu_puNwXAwIcRaZel0tmqYRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bb3bfc4f-8375-4579-a606-eec84c1318e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "13621 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "Heart rate–based, calorie-burning studio featuring group classes and workouts that can be tracked in real-time.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-8185-772c-9f91-954867edecf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-8185-772c-9f91-954867edecf6",
        "storage_key": "property/6767906449167617/019ff6a8-8185-772c-9f91-954867edecf6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/kansas/overland-park/13621-metcalf-ave/?utm_medium=seo&utm_source=gg&utm_term=tombras&utm_campaign=reputationdotcom--National",
      "poi_directions_map_url": "https://maps.google.com/?cid=2517780848240473361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "38.8814048",
      "poi_longitude": "-94.6672773",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-213-1012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz2AK5sLBwIcREbWneVf08CI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3f835d91-439c-40da-a27c-49f5e7b1cd47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Pilates by Kahley",
      "poi_type": "Health and Wellness",
      "poi_address": "12503 Hemlock St, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6cc-e5da-765f-bd0d-5f835a47d859.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-e5da-765f-bd0d-5f835a47d859",
        "storage_key": "property/6767906449167617/019ff6cc-e5da-765f-bd0d-5f835a47d859.webp",
        "width": 1280,
        "height": 879
      },
      "poi_business_url": "http://www.pilatesbykahley.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15148532197043977755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pilates-by-kahley",
      "poi_latitude": "38.9001595",
      "poi_longitude": "-94.6817306",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-469-0001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dc1-77e5-933f-cc588638edc7",
        "storage_key": "property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6wyesHTqwIcRG75f2cVlOtI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_cf9beee4-fe1d-4b62-82f7-4e4075760021",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - Metcalf Super Sport",
      "poi_type": "Health and Wellness",
      "poi_address": "12075 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66c-218d-74c8-ba69-16e785b0abc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-218d-74c8-ba69-16e785b0abc9",
        "storage_key": "property/6767906449167617/01a0b66c-218d-74c8-ba69-16e785b0abc9.webp",
        "width": 867,
        "height": 488
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/metcalf-super-sport.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=6750749210914447438&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "genesis-health-clubs---metcalf-super-sport",
      "poi_latitude": "38.9095897",
      "poi_longitude": "-94.6661065",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-338-2442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkeOYr2zqwIcRTuBN7KN6r10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_af8e3f84-e1ff-4661-9c98-68fe27406cc0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Scheels Overland Park Soccer Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13700 Switzer Rd, Overland Park, KS 66221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6cc-e9c1-7744-a85f-2520ae192385.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-e9c1-7744-a85f-2520ae192385",
        "storage_key": "property/6767906449167617/019ff6cc-e9c1-7744-a85f-2520ae192385.webp",
        "width": 1280,
        "height": 894
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/soccer-complex/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3095772957620985062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scheels-overland-park-soccer-complex",
      "poi_latitude": "38.8802627",
      "poi_longitude": "-94.7045196",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-685-1512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG9T6_zzAwIcR5lxCVBpl9io",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_7d090025-2be0-487f-9836-dd084c4eda64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Switzer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10917-10965 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "Park with facilities for tennis, pickleball, and kids' play, plus fields.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-8631-75e8-8f3a-89dec6abdb73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-8631-75e8-8f3a-89dec6abdb73",
        "storage_key": "property/6767906449167617/019ff6a8-8631-75e8-8f3a-89dec6abdb73.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.opkansas.org/things-to-see-and-do/parks/list-of-city-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3593908157756993174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "switzer-park",
      "poi_latitude": "38.8831256",
      "poi_longitude": "-94.7102078",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7e8f-77eb-ae5d-d5020efaf9fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7e8f-77eb-ae5d-d5020efaf9fd",
        "storage_key": "property/6767906449167617/019fc98b-7e8f-77eb-ae5d-d5020efaf9fd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbSAi0BnAwIcRlu57mm0g4DE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0c8e8078-5213-420d-8b48-dea666fd0288",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Tomahawk Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Overland Park, KS 66221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6cc-ec21-727e-9cc4-d76c982cc746.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-ec21-727e-9cc4-d76c982cc746",
        "storage_key": "property/6767906449167617/019ff6cc-ec21-727e-9cc4-d76c982cc746.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.opkansas.org/park/tomahawk-valley-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7472005189088649019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tomahawk-valley-park",
      "poi_latitude": "38.8765219",
      "poi_longitude": "-94.7209626",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7e8f-77eb-ae5d-d5020efaf9fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7e8f-77eb-ae5d-d5020efaf9fd",
        "storage_key": "property/6767906449167617/019fc98b-7e8f-77eb-ae5d-d5020efaf9fd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiyyLOgzAwIcROx-BjyHlsWc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4372d142-b28f-404e-a010-cdd5a7ced2a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Amesbury Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12500 W 143rd St, Overland Park, KS 66221, USA",
      "poi_short_description": "Compact park for the local community offering a playground & a picnic pavilion.",
      "poi_long_description": "Compact park for the local community offering a playground & a picnic pavilion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc994-3501-73fa-8980-d40f8fa03112.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-3501-73fa-8980-d40f8fa03112",
        "storage_key": "property/6767906449167617/019fc994-3501-73fa-8980-d40f8fa03112.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4440362089559726751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amesbury-lake-park",
      "poi_latitude": "38.87158",
      "poi_longitude": "-94.7344131",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-895-6390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7e8f-77eb-ae5d-d5020efaf9fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7e8f-77eb-ae5d-d5020efaf9fd",
        "storage_key": "property/6767906449167617/019fc98b-7e8f-77eb-ae5d-d5020efaf9fd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJP32izPK_wIcRn5pRXstVnz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8929cd47-e269-44b5-8b29-bfdc1171d45f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Nottingham South Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13889 Antioch Rd, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66c-230e-7784-a002-90af832886b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-230e-7784-a002-90af832886b1",
        "storage_key": "property/6767906449167617/01a0b66c-230e-7784-a002-90af832886b1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.opkansas.org/park/nottingham-south-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7395731420848069038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nottingham-south-park",
      "poi_latitude": "38.8770669",
      "poi_longitude": "-94.684718",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7e8f-77eb-ae5d-d5020efaf9fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7e8f-77eb-ae5d-d5020efaf9fd",
        "storage_key": "property/6767906449167617/019fc98b-7e8f-77eb-ae5d-d5020efaf9fd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJpZ5kuvHBwIcRrhnYAYvqomY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f557c17f-8396-4bbf-862e-cd5b9cffb12e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Regency Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14800 Lamar Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "Playground, swings and slides at this chill park featuring a lake and walking paths.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-8e62-724f-bcd1-ca382b8903a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-8e62-724f-bcd1-ca382b8903a9",
        "storage_key": "property/6767906449167617/019ff6a8-8e62-724f-bcd1-ca382b8903a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15463142209822193210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regency-lake-park",
      "poi_latitude": "38.8596074",
      "poi_longitude": "-94.6614219",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7e8f-77eb-ae5d-d5020efaf9fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7e8f-77eb-ae5d-d5020efaf9fd",
        "storage_key": "property/6767906449167617/019fc98b-7e8f-77eb-ae5d-d5020efaf9fd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZQkARJnBwIcROvbMn-kdmNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9c14d790-443c-4995-a883-067d3bd14743",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Antioch Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6501 Antioch Rd, Merriam, KS 66202, USA",
      "poi_short_description": "Lake, ponds, fountains and playgrounds in a park featuring paved trails and picnic areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66c-245f-7219-91ea-63ac479cbbe2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-245f-7219-91ea-63ac479cbbe2",
        "storage_key": "property/6767906449167617/01a0b66c-245f-7219-91ea-63ac479cbbe2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jcprd.com/facilities/facility/details/Antioch-Park-13",
      "poi_directions_map_url": "https://maps.google.com/?cid=10770084381401580462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "antioch-park",
      "poi_latitude": "39.0111512",
      "poi_longitude": "-94.685656",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 913-831-3359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7e8f-77eb-ae5d-d5020efaf9fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7e8f-77eb-ae5d-d5020efaf9fd",
        "storage_key": "property/6767906449167617/019fc98b-7e8f-77eb-ae5d-d5020efaf9fd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxaLynlfswIcRroNsuq4Gd5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_baa20d15-9d91-419a-ab19-c4907dd13f4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Midwest Trust Center",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_long_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-8b55-701b-be3b-60e983b58ecf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-8b55-701b-be3b-60e983b58ecf",
        "storage_key": "property/6767906449167617/019ff6a8-8b55-701b-be3b-60e983b58ecf.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jccc.edu/midwest-trust-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=333406106616415315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midwest-trust-center",
      "poi_latitude": "38.9252624",
      "poi_longitude": "-94.7279145",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-469-4445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRU0TRZhZ_oAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_534bffbe-f79c-4266-ac9c-a4bdcc772f25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Mission Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5251 Johnson Dr, Roeland Park, KS 66205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ridekc.org/locations/mission_transit_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750820283784844061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-transit-center",
      "poi_latitude": "39.0229186",
      "poi_longitude": "-94.6460432",
      "poi_miles_from_property": "13.4",
      "poi_walking_minutes": "4 hours 58 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-a7ba-76bd-9cc7-68563c7f2f83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-a7ba-76bd-9cc7-68563c7f2f83",
        "storage_key": "property/6767906449167617/019ff6a8-a7ba-76bd-9cc7-68563c7f2f83.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RGVf9XtwIcRHVOfGOVwtcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_f829b1a0-3b42-41b8-9a24-fde09cdff12c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Oak Park Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16122160475460681538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall-park--ride",
      "poi_latitude": "38.9552209",
      "poi_longitude": "-94.7216049",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-a7ba-76bd-9cc7-68563c7f2f83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-a7ba-76bd-9cc7-68563c7f2f83",
        "storage_key": "property/6767906449167617/019ff6a8-a7ba-76bd-9cc7-68563c7f2f83.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwpg4UnrwIcRQj-tl4hrvd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_7a3984d9-669e-4b1f-a615-6dc405a5e88a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Shawnee Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "15205 W 63rd St, Shawnee, KS 66217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66c-2570-719c-b448-77afcd8fcc31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-2570-719c-b448-77afcd8fcc31",
        "storage_key": "property/6767906449167617/01a0b66c-2570-719c-b448-77afcd8fcc31.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.shawneestation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10589385567007713794&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shawnee-station",
      "poi_latitude": "39.013604",
      "poi_longitude": "-94.7625242",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-a7ba-76bd-9cc7-68563c7f2f83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-a7ba-76bd-9cc7-68563c7f2f83",
        "storage_key": "property/6767906449167617/019ff6a8-a7ba-76bd-9cc7-68563c7f2f83.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJOd4JSQKTwIcRAqokdxEO9ZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_74ad2528-4e8e-4a48-af0f-a742739cb5dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc993-902f-748a-8469-773c973da303.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-902f-748a-8469-773c973da303",
        "storage_key": "property/6767906449167617/019fc993-902f-748a-8469-773c973da303.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3013901",
      "poi_longitude": "-94.7104232",
      "poi_miles_from_property": "41.2",
      "poi_walking_minutes": "15 hours 16 mins",
      "poi_biking_minutes": "4 hours 31 mins",
      "poi_driving_minutes": "44 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-8f63-775d-85e6-beea62a7a4b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-8f63-775d-85e6-beea62a7a4b8",
        "storage_key": "property/6767906449167617/019fc98b-8f63-775d-85e6-beea62a7a4b8.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_ce87cde5-18a8-4b33-84a9-affab1ae023b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Kansas City",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 W Pershing Rd Union Station, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0100e-e070-70fb-b3c6-cf095db2e7a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100e-e070-70fb-b3c6-cf095db2e7a2",
        "storage_key": "property/6767906449167617/01a0100e-e070-70fb-b3c6-cf095db2e7a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=KCY",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787247529242741214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city",
      "poi_latitude": "39.0847966",
      "poi_longitude": "-94.5853578",
      "poi_miles_from_property": "19.2",
      "poi_walking_minutes": "7 hours 4 mins",
      "poi_biking_minutes": "1 hour 58 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0100f-0265-775a-8a85-2327add70284.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0100f-0265-775a-8a85-2327add70284",
        "storage_key": "property/6767906449167617/01a0100f-0265-775a-8a85-2327add70284.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbu2nD_wwIcR3kn96I8BjzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_a477bda0-e600-4225-9bb6-f824b60b16cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Strang Line Road Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3436547488501433531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "strang-line-road-park-and-ride",
      "poi_latitude": "38.9082495",
      "poi_longitude": "-94.774183",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6cc-ffb5-71ba-a7c0-c5954ea1a010.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6cc-ffb5-71ba-a7c0-c5954ea1a010",
        "storage_key": "property/6767906449167617/019ff6cc-ffb5-71ba-a7c0-c5954ea1a010.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJI1GA1J6VwIcRu4TjsbsRsS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_7a4ee4d3-0099-458b-aec2-ea133a68732f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Aspiria",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6140 Sprint Pkwy STE 125, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66c-2b59-7055-99be-10cdbec21129.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-2b59-7055-99be-10cdbec21129",
        "storage_key": "property/6767906449167617/01a0b66c-2b59-7055-99be-10cdbec21129.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://aspiriakc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6433786320914474865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aspiria",
      "poi_latitude": "38.9169728",
      "poi_longitude": "-94.6568885",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 913-285-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0ZxsczrwIcRceffOpJmSVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_07002557-35b7-4995-8a11-d8b0fdce8e49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Garmin",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-3b55-76a7-85fb-065c9e86a5ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98b-3b55-76a7-85fb-065c9e86a5ad",
        "storage_key": "property/6767906449167617/019fc98b-3b55-76a7-85fb-065c9e86a5ad.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.garmin.com/en-US",
      "poi_directions_map_url": "https://maps.google.com/?cid=7856958804647333168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garmin",
      "poi_latitude": "38.8553721",
      "poi_longitude": "-94.7996464",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-800-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdY73mS-wIcRMM3hpWeGCW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_39fcd4bc-e1b4-4a42-a4d4-eefd21590f86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Black & Veatch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11401 Lamar Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc993-dc06-712b-b44e-bc3306baebb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-dc06-712b-b44e-bc3306baebb7",
        "storage_key": "property/6767906449167617/019fc993-dc06-712b-b44e-bc3306baebb7.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "http://www.bv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15245877116558125981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black--veatch",
      "poi_latitude": "38.9250015",
      "poi_longitude": "-94.6553624",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 913-458-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e",
        "storage_key": "property/6767906449167617/019fc98b-7cb3-74fe-88c9-e5b8b33c1d7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyTe2TrqwIcRnSu0HXY8lNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_4e6ac75e-2477-41f4-b48f-ca7fd431796e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "OptumRx Fulfillment",
      "poi_type": "Health and Wellness",
      "poi_address": "6800 W 115th St suite 600, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0100e-e1d1-745d-8509-75287a150173.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100e-e1d1-745d-8509-75287a150173",
        "storage_key": "property/6767906449167617/01a0100e-e1d1-745d-8509-75287a150173.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9191309365621035853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "optumrx-fulfillment",
      "poi_latitude": "38.9190643",
      "poi_longitude": "-94.662952",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-a6b2-73d3-b469-0c85e556d0db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-a6b2-73d3-b469-0c85e556d0db",
        "storage_key": "property/6767906449167617/019ff6a8-a6b2-73d3-b469-0c85e556d0db.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOSlrPD_qwIcRTROQnisXjn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_27dede85-cd43-41ce-96eb-9eecfde991e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Blue Valley School District Office #229",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15020 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bluevalleyk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12406361877646761667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-valley-school-district-office-229",
      "poi_latitude": "38.8566433",
      "poi_longitude": "-94.6685552",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-239-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dc1-77e5-933f-cc588638edc7",
        "storage_key": "property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkUYMDKHBwIcRw14VYGVALKw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cb0a3f4a-859b-4744-aaa4-8c0f39c3deae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "SMSD Center for Academic Achievement",
      "poi_type": "Education",
      "poi_address": "8200 W 71st St, Overland Park, KS 66204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6cc-f914-7508-8a60-3de79ef9bb7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-f914-7508-8a60-3de79ef9bb7c",
        "storage_key": "property/6767906449167617/019ff6cc-f914-7508-8a60-3de79ef9bb7c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13529336476659713433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smsd-center-for-academic-achievement",
      "poi_latitude": "39.0014907",
      "poi_longitude": "-94.6802101",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 53 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 913-993-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-7dc1-77e5-933f-cc588638edc7",
        "storage_key": "property/6767906449167617/019fc98b-7dc1-77e5-933f-cc588638edc7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF9r8VFzswIcRmYUJEtjbwbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_996875cf-3b74-4fbb-a16b-94800099cf4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "poi_name": "Johnson County Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "111 S Cherry St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-9cdb-74e8-9645-120583c69d1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-9cdb-74e8-9645-120583c69d1b",
        "storage_key": "property/6767906449167617/019ff6a8-9cdb-74e8-9645-120583c69d1b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jocogov.org/contact-us/all-locations/administration-building",
      "poi_directions_map_url": "https://maps.google.com/?cid=15575052816225759890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-administration-building",
      "poi_latitude": "38.8815028",
      "poi_longitude": "-94.8200342",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-715-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/019ff6a8-a77c-73b9-b9fb-7a16717d3820.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-a77c-73b9-b9fb-7a16717d3820",
        "storage_key": "property/6767906449167617/019ff6a8-a77c-73b9-b9fb-7a16717d3820.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9_Fbvq9wIcRknIVJQS0Jdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_2abc4388b2d8d9442673eb22",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_3f6b32f8461e7ef32deb149b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_9bc157c173941575cc5ded3f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e9d4ef2ec29cc68f2a8d09ff",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_1a880b45c48672ecdb4c4d62",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_eee5d8b12514456181f936db",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_143e21401acd12b0e353a386",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "rating": "5",
      "name": "Jenny Diaz",
      "text": "Great place to live. The workers here are the best part . Especially maintenance. A great helpful team that really care. Take care of issues quickly",
      "date": "2026-07-31",
      "title": "false"
    },
    {
      "id": "ec_81120d9152f2b3fc5c7eddde",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "rating": "5",
      "name": "Janet Lofland",
      "text": "I just moved in at the beginning of this month March and I Love my new apartment!I did get the smallest one but it fits my needs.My apartment is actually bigger then i thought it would be!My bedroom is actually pretty big!My bathroom is nice sized too!Kitchen size is Great!My balcony is really big!I want to give all the ladies in the office a shout out because they helped so much in the move in process and made a  Great experience for me.The communication was good.They even checked on me after i moved in to make sure everything was good.Also my son in law lived here before him and my daughter were married and of course my daughter was there alot too with him but i visited them a few years ago when they lived here and the two pools and gyms are so nice!The amenities are so good here!My neighbors are quiet and helpful!I can not say enough good things about these apartments!🙂🙂🙂",
      "date": "2026-03-14",
      "title": "false"
    },
    {
      "id": "ec_37f50b7c5459d69086d97641",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "rating": "5",
      "name": "Kaley Raber",
      "text": "I have lived at 2 apartments within Stonepost Ranch and have absolutely loved both! I just transferred to a new apartment and my experience with Keagan was great! She was prompt, informative and went above and beyond to make sure my move in went smooth. The maintenance team is always quick to help as well.",
      "date": "2025-10-30",
      "title": "false"
    },
    {
      "id": "ec_3d94178031a8b90ddc69be3d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "rating": "4",
      "name": "C3 Real Estate Investments",
      "text": "Great place to live. Lots of activities and functions for the tenants. 2 pools to take advantage of. They salt the sidewalks when there is ice or snow. As a tenant your able to rent out the club house for birthday parties or special events.",
      "date": "2019-05-08",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_a02bfe947e94589e7c47e8a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-8a3d-7331-9bf6-b60e2ba54632.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66e-8a3d-7331-9bf6-b60e2ba54632",
        "storage_key": "property/6767906449167617/01a0b66e-8a3d-7331-9bf6-b60e2ba54632.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Cheyenne - Ranch Phase",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ijCHNvFqoCN"
    },
    {
      "id": "ec_cad592afc56265bb58eee0bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-8812-705c-bb3b-b7a887b16bbc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66e-8812-705c-bb3b-b7a887b16bbc",
        "storage_key": "property/6767906449167617/01a0b66e-8812-705c-bb3b-b7a887b16bbc.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Cody - Valley Phase",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=34rby45AqJi"
    },
    {
      "id": "ec_4142ab1420f3e811c92bc5d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-8927-729c-b897-5a152b3f9526.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66e-8927-729c-b897-5a152b3f9526",
        "storage_key": "property/6767906449167617/01a0b66e-8927-729c-b897-5a152b3f9526.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Frisco - Ranch Phase",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=bbHjvgQYmKw"
    },
    {
      "id": "ec_71dbf5de0859f6615cca7446",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-8424-77c4-b2d0-3d23871882e6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66e-8424-77c4-b2d0-3d23871882e6",
        "storage_key": "property/6767906449167617/01a0b66e-8424-77c4-b2d0-3d23871882e6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fremont - Valley Phase",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=evaFdhLKtwx"
    },
    {
      "id": "ec_640816af87a69f87b859b5a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-81de-728a-a55a-51761a8b3ec8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66e-81de-728a-a55a-51761a8b3ec8",
        "storage_key": "property/6767906449167617/01a0b66e-81de-728a-a55a-51761a8b3ec8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Bandera - Ranch Phase",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=vNS6qz6QsHK"
    },
    {
      "id": "ec_fcaa01a1f2bc4599b7a962ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-96bd-77cc-bb1f-b70c1c0c20a4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66e-96bd-77cc-bb1f-b70c1c0c20a4",
        "storage_key": "property/6767906449167617/01a0b66e-96bd-77cc-bb1f-b70c1c0c20a4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sierra - Ranch Phase",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DRAXeBaAsda"
    },
    {
      "id": "ec_5f29ae7bd15a3f70d7bd03dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-9466-77ee-8cbb-f5be1428a5e0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66e-9466-77ee-8cbb-f5be1428a5e0",
        "storage_key": "property/6767906449167617/01a0b66e-9466-77ee-8cbb-f5be1428a5e0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sonoma - Ranch Phase",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=g4skGKXUMvd"
    },
    {
      "id": "ec_5acc72b79e7715f60a825d0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-94c2-7618-8b70-3492c30cde30.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66e-94c2-7618-8b70-3492c30cde30",
        "storage_key": "property/6767906449167617/01a0b66e-94c2-7618-8b70-3492c30cde30.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Henly - Ranch Phase",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=92msTeHrjGi"
    },
    {
      "id": "ec_65a6d708417483a533dc1fde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-a0f6-742d-953a-d95572142012.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66e-a0f6-742d-953a-d95572142012",
        "storage_key": "property/6767906449167617/01a0b66e-a0f6-742d-953a-d95572142012.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Sheridan - Valley Phase",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5hm7wSVKqW6"
    },
    {
      "id": "ec_deaf0a79c32560f2156a1986",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-958a-742d-b94e-eecdede82a03.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66e-958a-742d-b94e-eecdede82a03",
        "storage_key": "property/6767906449167617/01a0b66e-958a-742d-b94e-eecdede82a03.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Jackson - Valley Phase",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Mp8gZVFsPaj"
    },
    {
      "id": "ec_6bea03f86b32bcdd777d2c8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-ac8b-755d-8a09-61beac34d809.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66e-ac8b-755d-8a09-61beac34d809",
        "storage_key": "property/6767906449167617/01a0b66e-ac8b-755d-8a09-61beac34d809.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Dakota - Ranch Phase",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=qEP1g9oQ2XW"
    },
    {
      "id": "ec_f34d02d5d4193e79d82ff7ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "3 bedroom, 2 bathroom.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167617/01a0b66e-ad15-7606-b792-85db9c9ffffc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66e-ad15-7606-b792-85db9c9ffffc",
        "storage_key": "property/6767906449167617/01a0b66e-ad15-7606-b792-85db9c9ffffc.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Stonepost - Valley Phase",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mPzUHDNn8Kc"
    }
  ],
  "faqs": [
    {
      "id": "custom_55e44c30-4844-4794-96dc-eb10796549ff",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_0e20f102-aa9c-4f12-9186-0e1dafc63030",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_62a109f5-3261-4074-9966-414b24f85362",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_37a5d62f-f574-42b3-864f-5d32b84154bc",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_72d3235c-f953-450d-ab29-64ee8d6f5519",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_e5ca058f-a8ab-4181-a792-6f2be74fbee3",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_41ae3f81-d43f-46c5-904c-04022d65b232",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_a5abdb06-8853-4fb9-9fc5-f215036f70c5",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, sewer, trash, and electric.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_2b85c959-0e37-4a57-b6f0-7ca9858aa269",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_28b0fda8-8b72-430a-a8ac-2bff17c2e1fc",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_7425b7b3-4a5c-46f0-b8e9-c8854f666d53",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_7b1efc89-ae92-40d4-b8f1-22165ed5a101",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_476dfe7c-78fa-4926-8ef4-6a5b39859972",
      "question": "Do you offer covered parking?",
      "answer": "Yes, several of our apartment homes offer attached garages. We also offer detached garages. Please <a href=\"/contact-us\">contact the office</a> for our most current pricing and availability.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_eba7eba3-c6c7-4627-a851-57a499c821f9",
      "question": "What does \"Ranch Phase\" and \"Valley Phase\" mean in the floorplan names?",
      "answer": "The Stonepost Ranch community is comprised of two phases - Ranch and Valley. The Ranch phase has maple cabinetry. The Valley phase is comprised of espresso cabinetry, stainless appliances, and wood-style vinyl flooring in living areas in select apartment homes.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_616d761f-9011-484b-baca-daddec2b10fd",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_9a123a8c-4039-4f7e-bcbc-c7632dc64185",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_9c157620-59ac-4ca0-9a32-843056e905f1",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-4952-73fe-aa37-6cf70fdb4fbd",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Stonepost Ranch Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617"
    },
    {
      "lead_collector_id": "01a0c9ac-49df-738a-8163-6c004503fc64",
      "lead_source": "LANDING_PAGE",
      "name": "Stonepost Ranch Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "apartments-with-pool-in-overland-park-ks",
      "search_query": "apartments with pool in Overland Park KS",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Overland Park, KS",
      "h2_subtitle": "Discover the joy of living in South Overland Park. Find Stonepost Ranch Apartment Homes' resort-style amenities with a sparkling pool.",
      "page_copy": "Looking for apartments with pool in Overland Park, KS? Look no further than Stonepost Ranch Apartment Homes. Nestled in the tranquil setting of South Overland Park, our community offers exceptional one-, two-, and three-bedroom floor plans designed to meet diverse lifestyle needs. Whether you're enjoying quality time indoors or taking a refreshing dip in our sparkling pool, Stonepost Ranch ensures a perfect balance of comfort and recreation.\n\nBeyond just soaking up the sun by the pool, residents benefit from a variety of luxurious amenities. Picture yourself unwinding in spacious living areas or gathering with friends around the kitchen island. Detached garages are also available, adding everyday convenience to these stunning residences. Embrace resort-style living and schedule a tour today to see all that Stonepost Ranch Apartment Homes has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Overland Park, KS",
      "seo_description": "Explore Stonepost Ranch's apartments with pool in Overland Park, KS. Enjoy resort-style living and spacious floor plans in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-johnson-county",
      "search_query": "air conditioned apartments Johnson County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Johnson County",
      "h2_subtitle": "Stay cool at Stonepost Ranch Apartment Homes. Experience comfortable living with top-notch air conditioning in our spacious units.",
      "page_copy": "Searching for air conditioned apartments in Johnson County? Stonepost Ranch Apartment Homes offers perfectly climate-controlled living spaces that ensure you stay cool and comfortable year-round. Our one-, two-, and three-bedroom options are designed with your comfort in mind, allowing you to unwind with ease in South Overland Park.\n\nAt Stonepost Ranch, air conditioning is just the beginning of the luxurious features available to our residents. Enjoy quiet evenings in spacious interiors or explore our community amenities such as the resort-style pool. With detached garages available and a wheelchair accessible design, our property promises both comfort and convenience. Visit us today to discover your ideal air-conditioned apartment in the heart of Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Johnson County",
      "seo_description": "Find air conditioned apartments at Stonepost Ranch in Johnson County. Enjoy comfort and luxury in prime South Overland Park location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "stonepost-ranch-apartments-business-center",
      "search_query": "stonepost ranch apartments with business center",
      "category": "Amenity",
      "h1_title": "Stonepost Ranch Apartments with Business Center",
      "h2_subtitle": "Enhance your work-life balance at Stonepost Ranch. Access our convenient business center among other premium amenities.",
      "page_copy": "For those seeking a work-friendly environment, Stonepost Ranch Apartments with a business center provide the perfect solution. Located in South Overland Park, our community offers spacious one-, two-, and three-bedroom floor plans designed to accommodate a variety of lifestyles. Whether you're working remotely or need a dedicated space for productivity, our business center is a valuable amenity.\n\nBeyond the business center, Stonepost Ranch enhances your living experience with resort-style amenities and polished in-home features. Enjoy the luxury of a kitchen island* and convenient accessibility options including wheelchair-accessible rooms. With detached garages and a welcoming community atmosphere, Stonepost Ranch Apartments promise to be the ideal living space for both work and relaxation. Schedule a tour today and elevate your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stonepost Ranch Apartments with Business Center",
      "seo_description": "Discover Stonepost Ranch Apartments with a business center in Overland Park. Enjoy a blend of work and leisure with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "overland-park-apartments-in-unit-laundry",
      "search_query": "overland park apartments with in unit laundry",
      "category": "Amenity",
      "h1_title": "Overland Park Apartments with In-Unit Laundry",
      "h2_subtitle": "Experience the convenience of in-unit laundry at Stonepost Ranch. Enjoy modern living in the heart of South Overland Park.",
      "page_copy": "Finding Overland Park apartments with in-unit laundry is made easy at Stonepost Ranch Apartment Homes. Situated in the serene neighborhood of Outlying Johnson County KS, our community offers one-, two-, and three-bedroom floor plans that feature the luxury of in-unit laundry facilities. Relish the convenience of doing laundry in the comfort of your own home without any hassle.\n\nAt Stonepost Ranch, our commitment to providing a comfortable and modern lifestyle goes beyond just laundry. Enjoy resort-style amenities such as a sparkling pool and flexible living spaces that include features like kitchen islands* and detached garages. With attentive property management and accessibility options, our apartments offer the perfect setting for a relaxed yet upscale living experience in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Apartments with In-Unit Laundry",
      "seo_description": "Discover Stonepost Ranch Apartments with in-unit laundry in Overland Park. Embrace convenience and modern comfort in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "luxury-apartments-gym-66221",
      "search_query": "luxury apartments with gym in 66221",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Gym in 66221",
      "h2_subtitle": "Find luxury living with an onsite gym at Stonepost Ranch. Experience prime amenities in the 66221 area of Overland Park.",
      "page_copy": "Looking for luxury apartments with a gym in the 66221 area? Stonepost Ranch Apartment Homes offers an upscale living experience in South Overland Park. Our community boasts modern one-, two-, and three-bedroom floor plans tailored for comfort and style. Residents can enjoy exclusive access to a state-of-the-art gym, perfect for maintaining a healthy lifestyle just steps from home.\n\nBeyond our fitness center, Stonepost Ranch provides resort-like amenities such as spacious layouts with kitchen islands*, detached garages, and meticulously maintained grounds. Situated in the heart of Outlying Johnson County KS, our apartments are designed for those who value both luxury and convenience. Discover the ultimate living experience by scheduling a tour at Stonepost Ranch today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Gym in 66221",
      "seo_description": "Explore luxury living at Stonepost Ranch with a gym in 66221. Enjoy top-tier amenities in South Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-overland-park-ks",
      "search_query": "one bedroom apartments Overland Park KS",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Overland Park, KS",
      "h2_subtitle": "Discover comfortable one-bedroom living at Stonepost Ranch in Overland Park, KS.",
      "page_copy": "Searching for one-bedroom apartments in Overland Park, KS? Stonepost Ranch Apartment Homes offers spacious and well-designed one-bedroom floor plans that cater to your needs. Nestled in the welcoming community of South Overland Park, you'll find a peaceful living environment enriched with resort-style amenities.\n\nOur one-bedroom units provide not only the perfect space for relaxation but also a host of contemporary features such as kitchen islands* and in-unit laundry. While enjoying the luxury of detached garages and wheelchair-accessible options, you'll have everything you need for comfortable living. Embrace both convenience and style at Stonepost Ranch—schedule your personal tour today and envision your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Overland Park, KS",
      "seo_description": "Find your ideal one-bedroom apartment at Stonepost Ranch in Overland Park, KS. Enjoy modern amenities in a cozy community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-johnson-county-ks",
      "search_query": "two bedroom apartments Johnson County KS",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Johnson County, KS",
      "h2_subtitle": "Explore spacious two-bedroom living at Stonepost Ranch in Johnson County, KS.",
      "page_copy": "For those seeking two-bedroom apartments in Johnson County, KS, Stonepost Ranch Apartment Homes provides the ideal blend of space, style, and convenience. Our thoughtfully designed two-bedroom floor plans offer ample living space, comfort, and privacy.\n\nLocated in the serene setting of Outlying Johnson County, KS, residents enjoy a well-rounded lifestyle with modern features such as kitchen islands* and accessible options. Additionally, indulge in resort-like amenities and detached garages. Stonepost Ranch truly combines luxury with practicality, making it the perfect home. Schedule a visit to experience our vibrant community firsthand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Johnson County, KS",
      "seo_description": "Discover spacious two-bedroom apartments at Stonepost Ranch in Johnson County, KS. Experience modern amenities and comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-66221",
      "search_query": "three bedroom apartments near 66221",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 66221",
      "h2_subtitle": "Find expansive three-bedroom apartments at Stonepost Ranch, near 66221, offering comfort and style.",
      "page_copy": "If you're searching for three-bedroom apartments near the 66221 area, Stonepost Ranch Apartment Homes might be the perfect place to call home. Located in South Overland Park, our spacious three-bedroom floor plans offer the perfect setting for anyone needing extra space.\n\nOur community is designed with your lifestyle in mind, providing convenient features like kitchen islands* and highly sought-after amenities such as resort-style facilities. With both practicality and elegance, Stonepost Ranch stands out as a prime choice for luxurious living in Outlying Johnson County, KS. Schedule your tour today to explore the advantages of living here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 66221",
      "seo_description": "Explore spacious three-bedroom apartments at Stonepost Ranch near 66221 - ideal for comfort and luxury in Overland Park, KS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "apartments-near-california-trail-middle-school",
      "search_query": "apartments near California Trail Middle School Overland Park",
      "category": "School",
      "h1_title": "Apartments Near California Trail Middle School",
      "h2_subtitle": "Stonepost Ranch offers convenient apartment living near California Trail Middle School in Overland Park.",
      "page_copy": "Looking for apartments near California Trail Middle School in Overland Park? Stonepost Ranch Apartment Homes provides a perfect living solution just a short distance away. Our community offers one-, two-, and three-bedroom floor plans designed to complement your lifestyle.\n\nLocated in the heart of Johnson County, you'll enjoy the dual benefit of comfort and convenience. With features such as a property manager on-site and detached garages, our residents experience hassle-free living. Additionally, the resort-style amenities create a welcoming environment for both relaxation and entertainment. Experience it all by scheduling a tour at Stonepost Ranch today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near California Trail Middle School",
      "seo_description": "Find convenient apartments near California Trail Middle School at Stonepost Ranch in Overland Park, offering comfort and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "apartments-near-overland-trail-elementary-school",
      "search_query": "apartments close to Overland Trail Elementary School KS",
      "category": "School",
      "h1_title": "Apartments Close to Overland Trail Elementary School",
      "h2_subtitle": "Discover convenient living at Stonepost Ranch, near Overland Trail Elementary School in KS.",
      "page_copy": "Stonepost Ranch Apartment Homes offers the ideal setting for those seeking apartments close to Overland Trail Elementary School in KS. Our community offers spacious one-, two-, and three-bedroom floor plans that provide the perfect backdrop for daily life.\n\nResiding in our South Overland Park location means you'll have quick and easy access to one of the top educational institutions in the area. Our apartments highlight comfort and modern living with amenities like resort-style facilities and available detached garages. Experience the seamless blend of convenience and quality at Stonepost Ranch by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Overland Trail Elementary School",
      "seo_description": "Find apartments close to Overland Trail Elementary School at Stonepost Ranch in Overland Park, KS, offering comfort and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "overland-trail-middle-school-nearby-apartments",
      "search_query": "Overland Trail Middle School nearby apartments",
      "category": "School",
      "h1_title": "Nearby Apartments to Overland Trail Middle School",
      "h2_subtitle": "Live near Overland Trail Middle School at Stonepost Ranch, offering spacious layouts and modern amenities in Overland Park, KS.",
      "page_copy": "If you're on the lookout for Overland Trail Middle School nearby apartments, Stonepost Ranch Apartment Homes offers an exceptional option. Positioned in Overland Park, KS, our community provides the perfect blend of convenience and luxury, just a short drive from the school.\n\nOur diverse selection of one-, two-, and three-bedroom floor plans offers both proximity to the school and a vibrant living environment. With resort-style amenities and in-home features like kitchen islands*, Stonepost Ranch ensures comfort and style. Experience comfortable living and schedule a tour of our community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Trail Middle School",
      "seo_description": "Find nearby apartments to Overland Trail Middle School at Stonepost Ranch in Overland Park. Spacious layouts and modern amenities await!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "blue-valley-northwest-high-school-apartment-rentals",
      "search_query": "Blue Valley Northwest High School apartment rentals",
      "category": "School",
      "h1_title": "Apartment Rentals Near Blue Valley Northwest High School",
      "h2_subtitle": "Discover Stonepost Ranch's rentals, located conveniently near Blue Valley Northwest High School in Overland Park.",
      "page_copy": "Stonepost Ranch Apartment Homes offers apartment rentals near Blue Valley Northwest High School, providing an ideal living environment in Overland Park. Nestled in Overland Park, our community ensures easy access to this renowned high school while providing a plethora of features to enhance your lifestyle.\n\nChoose from one-, two-, and three-bedroom floor plans, each designed with modern living in mind. Our amenities, which include a property manager on-site and resort-style features, make living here both convenient and luxurious. Embrace a community that prioritizes proximity to quality education and a comfortable lifestyle by scheduling a tour of Stonepost Ranch today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Blue Valley Northwest High School",
      "seo_description": "Explore ideal apartment rentals near Blue Valley Northwest High School at Stonepost Ranch in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "bentwood-elementary-school-apartments-66221",
      "search_query": "Bentwood Elementary School apartments 66221",
      "category": "School",
      "h1_title": "Apartments Near Bentwood Elementary School 66221",
      "h2_subtitle": "Find ideal homes at Stonepost Ranch, near Bentwood Elementary School in the 66221 area. Convenience and quality in Overland Park.",
      "page_copy": "Looking for Bentwood Elementary School apartments in the 66221 area? Stonepost Ranch Apartment Homes offers a prime location in Overland Park, KS, with excellent proximity to Bentwood Elementary. Our community provides a welcoming atmosphere. \n\nOur spacious one-, two-, and three-bedroom floor plans offer a range of layouts, and our amenities promise a comfortable, engaging lifestyle. Enjoy features such as available detached garages, a walk-up design, and resort-style amenities that enhance everyday living. Stonepost Ranch is where community meets convenience. Book a tour and discover your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bentwood Elementary School 66221",
      "seo_description": "Discover apartments near Bentwood Elementary School in 66221 at Stonepost Ranch, Overland Park, with spacious layouts and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "apartments-by-blue-river-elementary-outlying-johnson-county",
      "search_query": "apartments by Blue River Elementary School Outlying Johnson County",
      "category": "School",
      "h1_title": "Find Apartments by Blue River Elementary School",
      "h2_subtitle": "Explore Stonepost Ranch, perfectly located by Blue River Elementary School in Outlying Johnson County, offering excellent amenities.",
      "page_copy": "For those seeking apartments by Blue River Elementary School in Outlying Johnson County, Stonepost Ranch Apartment Homes offers an unbeatable choice. Our community combines the best of suburban living with convenient access to local schools. \n\nLocated in South Overland Park, KS, our one-, two-, and three-bedroom floor plans offer quality living spaces close to the school. With amenities like wheelchair accessibility and walk-up options, along with a meticulously maintained environment, Stonepost Ranch provides a community where residents thrive. Schedule a tour today to see why we are the preferred choice in Outlying Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Blue River Elementary School Apartments",
      "seo_description": "Discover apartments near Blue River Elementary in Outlying Johnson County at Stonepost Ranch in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "johnson-county-community-college-student-apartments",
      "search_query": "Johnson County Community College student apartments",
      "category": "School",
      "h1_title": "Student Apartments Near Johnson County Community College",
      "h2_subtitle": "Stonepost Ranch offers student-friendly living near Johnson County Community College, providing comfort and convenience in Overland Park.",
      "page_copy": "Stonepost Ranch Apartment Homes presents an ideal option for students seeking apartments near Johnson County Community College. Located in Overland Park, our community caters to students with easy access to the college, making commuting hassle-free.\n\nOur selection of one-, two-, and three-bedroom floor plans ensures you find a suitable living arrangement to complement your educational pursuits. With amenities like a property manager on-site and available detached garages, Stonepost Ranch provides a supportive and convenient environment for college life. Experience comfortable student living by scheduling a tour with us today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Student Apartments Near Johnson County Community College",
      "seo_description": "Explore student apartments near Johnson County Community College at Stonepost Ranch in Overland Park, offering convenient living for students.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "apartments-near-overland-park-regional-medical-center",
      "search_query": "apartments near Overland Park Regional Medical Center",
      "category": "Hospital",
      "h1_title": "Apartments Near Overland Park Regional Medical Center",
      "h2_subtitle": "Discover comfort and convenience at Stonepost Ranch, located near Overland Park Regional Medical Center. Ideal for healthcare professionals.",
      "page_copy": "If you're looking for apartments near Overland Park Regional Medical Center, consider Stonepost Ranch Apartment Homes as your new residence. Positioned in South Overland Park, our community is perfect for medical professionals seeking nearby living options.\n\nOur spacious one-, two-, and three-bedroom floor plans offer both comfort and flexibility, catering to diverse needs. Enjoy resort-style amenities and in-home details designed to enhance your lifestyle. With easy access to the medical center and other conveniences in Outlying Johnson County, Stonepost Ranch ensures a balanced blend of work and relaxation. Schedule your tour today and experience the difference.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Park Regional Medical Center",
      "seo_description": "Find convenient apartments near Overland Park Regional Medical Center at Stonepost Ranch in South Overland Park, KS. Ideal for healthcare professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "apartments-near-overland-park-arboretum-botanical-gardens",
      "search_query": "apartments near Overland Park Arboretum & Botanical Gardens",
      "category": "Park",
      "h1_title": "Apartments Near Overland Park Arboretum & Gardens",
      "h2_subtitle": "Experience peaceful living at Stonepost Ranch, situated close to the Overland Park Arboretum & Botanical Gardens, where nature meets comfort.",
      "page_copy": "For nature enthusiasts, Stonepost Ranch Apartment Homes provide the perfect living experience near the Overland Park Arboretum & Botanical Gardens. Located in South Overland Park, our community blends natural beauty with modern convenience.\n\nWith options for one-, two-, and three-bedroom layouts, you can enjoy spacious living with polished details. Our resort-style amenities, including available detached garages and a wheelchair-accessible environment, make everyday life enjoyable and easy. Just a short drive from the arboretum and botanical gardens, Stonepost Ranch offers an ideal home base for exploring the lush landscapes and serene walking trails nearby.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Park Arboretum & Botanical Gardens",
      "seo_description": "Live near nature! Find apartments close to the Overland Park Arboretum & Botanical Gardens at Stonepost Ranch, combining tranquility and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "south-overland-park-apartments-by-switzer-park",
      "search_query": "South Overland Park apartments by Switzer Park",
      "category": "Park",
      "h1_title": "South Overland Park Apartments by Switzer Park",
      "h2_subtitle": "Stonepost Ranch offers prime living in South Overland Park, conveniently located near Switzer Park, perfect for those who love the outdoors.",
      "page_copy": "Positioned near Switzer Park, Stonepost Ranch Apartment Homes offer the perfect South Overland Park living experience for those who enjoy outdoor activities. With easy access to the park, residents can immerse themselves in a vibrant community while relishing the peace and quiet of our surroundings.\n\nOur one-, two-, and three-bedroom apartments are designed for comfort and style, featuring in-home amenities that enhance everyday living. The community also boasts resort-style amenities, including free-standing garages and walk-up access. Experience the ideal blend of nature and convenience by scheduling a visit to Stonepost Ranch today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "South Overland Park Apartments by Switzer Park",
      "seo_description": "Discover the perfect South Overland Park lifestyle at Stonepost Ranch, located near Switzer Park, offering spacious apartments and resort-style amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "tomahawk-valley-park-nearby-overland-park-rentals",
      "search_query": "Tomahawk Valley Park nearby Overland Park rentals",
      "category": "Park",
      "h1_title": "Rentals Near Tomahawk Valley Park, Overland Park",
      "h2_subtitle": "Explore rentals at Stonepost Ranch, conveniently located near Tomahawk Valley Park in Overland Park. Enjoy park-side living at its finest.",
      "page_copy": "Looking for Overland Park rentals near Tomahawk Valley Park? Stonepost Ranch Apartment Homes is an excellent choice, providing easy access to this local treasure. Our charming community offers a peaceful and convenient living experience with quick routes to the park's outdoor fun.\n\nInside our one-, two-, and three-bedroom apartments, you'll find elegantly appointed spaces with modern finishes, while outside, resort-style amenities await. From available detached garages to our property manager on-site, residents enjoy comfort and peace of mind. Embrace a lifestyle that balances green spaces and upscale living at Stonepost Ranch today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Tomahawk Valley Park, Overland Park",
      "seo_description": "Find Overland Park rentals near Tomahawk Valley Park at Stonepost Ranch. Enjoy spacious apartments with easy park access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "stonepost-ranch-living-near-amesbury-lake-park",
      "search_query": "Stonepost Ranch living near Amesbury Lake Park",
      "category": "Park",
      "h1_title": "Stonepost Ranch Living Near Amesbury Lake Park",
      "h2_subtitle": "Discover the comforts of Stonepost Ranch, ideally situated near the tranquil Amesbury Lake Park, offering a perfect blend of nature and home amenities.",
      "page_copy": "Embrace a life of comfort and leisure at Stonepost Ranch Apartment Homes, conveniently located near Amesbury Lake Park in South Overland Park. This proximity provides our residents with easy access to serene natural landscapes and beautifully maintained green spaces, ideal for relaxation or outdoor activities.\n\nOur range of one-, two-, and three-bedroom floor plans offers spacious living with refined in-home features. Just outside your door, enjoy the convenience of our resort-style amenities, including available detached garages and walk-up access. Enhance your lifestyle with a community that combines modern living and the tranquility of nearby natural beauty at Stonepost Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stonepost Ranch Living Near Amesbury Lake Park",
      "seo_description": "Enjoy Stonepost Ranch living near Amesbury Lake Park with spacious apartments and luxurious amenities, offering a harmonious blend of home and nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "overland-park-homes-close-to-nottingham-south-park",
      "search_query": "Overland Park homes close to Nottingham South Park",
      "category": "Park",
      "h1_title": "Overland Park Homes Near Nottingham South Park",
      "h2_subtitle": "Live in comfort at Stonepost Ranch, just a short distance from Nottingham South Park in Overland Park. Ideal for those seeking a balanced lifestyle.",
      "page_copy": "Stonepost Ranch Apartment Homes offer a premium living experience in Overland Park, just moments away from Nottingham South Park. This proximity ensures residents can easily enjoy the park's scenic trails and vibrant community events while residing in a welcoming and serene environment.\n\nOur thoughtfully designed apartments include one-, two-, and three-bedroom floor plans, each equipped with stylish interiors and practical touches. Outside your home, indulge in amenities such as available detached garages and a property manager on-site. Stonepost Ranch provides a harmonious blend of city convenience and suburban tranquility, making it the perfect place to call home near Nottingham South Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Homes Near Nottingham South Park",
      "seo_description": "Find Overland Park homes close to Nottingham South Park at Stonepost Ranch, offering spacious living with great amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "johnson-county-apartments-near-regency-lake-park",
      "search_query": "Johnson County apartments near Regency Lake Park",
      "category": "Park",
      "h1_title": "Johnson County Apartments by Regency Lake Park",
      "h2_subtitle": "Live nearby Regency Lake Park at Stonepost Ranch, offering premier apartment living in Johnson County. Enjoy the best of both nature and modern amenities.",
      "page_copy": "Welcome to Stonepost Ranch Apartment Homes, where you can experience the convenience of urban living with the tranquility of nearby Regency Lake Park. Located in Johnson County, our community provides immediate access to beautiful outdoor spaces, perfect for leisurely strolls or recreational activities.\n\nStonepost Ranch offers spacious one-, two-, and three-bedroom floor plans, each thoughtfully designed with modern interiors and high-quality finishes. Within our community, residents can enjoy amenities such as detached garages and on-site management. Embrace the ideal blend of comfort and convenience at our apartments near Regency Lake Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Johnson County Apartments by Regency Lake Park",
      "seo_description": "Discover Johnson County apartments near Regency Lake Park at Stonepost Ranch. Enjoy spacious layouts and premium amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "apartments-near-antioch-park-ks",
      "search_query": "apartments near Antioch Park KS",
      "category": "Park",
      "h1_title": "Apartments Near Antioch Park, KS",
      "h2_subtitle": "Explore living at Stonepost Ranch, conveniently located near Antioch Park, KS. Enjoy easy access to outdoor fun and exceptional living comforts.",
      "page_copy": "Discover the perfect blend of style and convenience at Stonepost Ranch Apartment Homes, nestled close to Antioch Park in Kansas. Our community offers residents the luxury of being just a quick drive away from this beloved recreational spot, filled with scenic trails and vibrant play areas.\n\nStonepost Ranch provides a variety of spacious one-, two-, and three-bedroom floor plans, each designed with polished finishes and modern conveniences. Enjoy life within our community with amenities like detached garages, walk-up access, and on-site management. Whether you're drawn by the allure of nearby Antioch Park or our excellent in-home features, Stonepost Ranch is the perfect place to settle in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Antioch Park, KS",
      "seo_description": "Find your ideal home at Stonepost Ranch, offering apartments near Antioch Park, KS. Enjoy spacious living with premium amenities close to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167617",
      "source": "custom",
      "page_item_url": "apartments-near-kansas-city-international-airport-overland-park",
      "search_query": "apartments near kansas city international airport overland park",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City International Airport",
      "h2_subtitle": "Choose Stonepost Ranch for premium living not far from the Kansas City International Airport. Perfect for frequent travelers seeking comfort in Overland Park.",
      "page_copy": "Stonepost Ranch Apartment Homes in Overland Park offer a strategic location for frequent flyers, conveniently situated within a commutable distance to Kansas City International Airport. This makes work trips and vacations seamless while enjoying a peaceful home environment away from the hustle and bustle.\n\nOur community features beautiful one-, two-, and three-bedroom floor plans with polished interiors and an array of resort-style amenities. With essentials like wheelchair accessible rooms and detached garages available, Stonepost Ranch provides comfort and convenience for every resident. Experience the ease of travel and the pleasure of superior apartment living, all in one place, near Kansas City International Airport.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a clubhouse.",
        "public_id": "019fc98b-60ec-7550-b2a8-1b8189876a13",
        "storage_key": "property/6767906449167617/019fc98b-60ec-7550-b2a8-1b8189876a13.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City International Airport",
      "seo_description": "Discover Stonepost Ranch apartments near Kansas City International Airport in Overland Park. Enjoy spacious living with easy airport access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701934612"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M8PQC6FL"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 5"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/cb2b1fc3-c8f3-4e8d-9efc-47c85f4f6df7/app.js?nocache=1&gaTracking=G-7TMMVYXKLK&buttonbgcolor=317472&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://homes.rently.com/apartments-for-rent/Stonepost%20Ranch/95680"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-380-4126"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im1nRnExdVdhS1g0K2hBZ0gxT3pnQ0E9PSIsInZhbHVlIjoiajgrckdnMTkxd0Z3ek5aRVlZNWs1Zz09IiwibWFjIjoiMmY2YzAyMGY1MzI2NGVhNTNjZmY1YTk3ZDRiNGY4ODFhNWViYTg2NjNkYTEzZDg3ZmFjZGFmMjkzOGI4OThjYiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701934612",
  "custom_google_gtm_id": "GTM-M8PQC6FL",
  "custom_rollout_phase": "Batch 5",
  "custom_vibesites_theme": "Rise",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/cb2b1fc3-c8f3-4e8d-9efc-47c85f4f6df7/app.js?nocache=1&gaTracking=G-7TMMVYXKLK&buttonbgcolor=317472&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_self_guided_tour_url": "https://homes.rently.com/apartments-for-rent/Stonepost%20Ranch/95680",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-380-4126",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im1nRnExdVdhS1g0K2hBZ0gxT3pnQ0E9PSIsInZhbHVlIjoiajgrckdnMTkxd0Z3ek5aRVlZNWs1Zz09IiwibWFjIjoiMmY2YzAyMGY1MzI2NGVhNTNjZmY1YTk3ZDRiNGY4ODFhNWViYTg2NjNkYTEzZDg3ZmFjZGFmMjkzOGI4OThjYiJ9",
  "custom_audioeye_site_id": "47bae9ee-76d2-4e8d-9bfe-35923533529a",
  "custom_audioeye_site_hash": "bdbed64bf0ca3dff4a898f0e4acff729"
};

export const generatedAt = '2026-11-03T22:58:15.555Z';
